import { LocaleMap } from '@unifocus/js-utils';

/**
 * WARNING: This file is auto-generated from the bundle-localization tool. Do not edit this file directly.
 *
 * This file contains resource strings used by the @unifocus/js-utils formatMessage function.
 */
const messages: LocaleMap = {
   "en": {
      "res_am": "AM",
      "res_anErrorHasOccurred": "An Error Has Occurred",
      "res_anErrorOccurredMessageLineOne": "An error occurred and your request cannot be completed.",
      "res_anErrorOccurredMessageLineTwo": "UniFocus has created an error report you can send to our troubleshooting team, so that we may provide better service in the future.",
      "res_applicationId": "Application Id",
      "res_at": "At",
      "res_build": "Build",
      "res_cancel": "Cancel",
      "res_clickToSelectOrgLayer": "Click to select an org. layer",
      "res_columns": "Columns",
      "res_columnsCannotBeLoaded": "Columns cannot be loaded",
      "res_columnsCannotBeDisplayedSingleColumnText": "1 column is not available to be displayed in your grid. This could be due to an application update.",
      "res_columnsCannotBeDisplayedMultipleColumnsText": "{0} columns are not available to be displayed in your grid. This could be due to an application update.",
      "res_collapseAll": "Collapse All",
      "res_continue": "Continue",
      "res_correlationId": "Correlation ID",
      "res_current": "Current",
      "res_databaseId": "Database ID",
      "res_delete": "Delete",
      "res_deleteView": "Delete view",
      "res_deleteViewText": "This will permanently remove the saved view from the database. This action cannot be undone.",
      "res_deselectAll": "Deselect All",
      "res_doNothing": "Do nothing",
      "res_dontSend": "Don't send",
      "res_errorCode": "Error Code",
      "res_errorMessage": "Error Message",
      "res_expandAll": "Expand All",
      "res_help": "Help",
      "res_fixProblem": "Fix Problem",
      "res_hideThisColumn": "Hide This Column",
      "res_invalidInput": "Invalid input",
      "res_load": "Load",
      "res_loadASavedView": "Load a saved view",
      "res_loadSaveViews": "Load / Save Views",
      "res_loadSelectedOrgLayer": "Load selected Org. layer",
      "res_method": "Method",
      "res_newViewName": "New view name",
      "res_next": "Next",
      "res_no": "No",
      "res_ok": "OK",
      "res_overwrite": "Overwrite",
      "res_overwriteExistingViewText": "The name you selected already exists. Do you want to overwrite the existing view?",
      "res_partnerCode": "Partner Code",
      "res_pm": "PM",
      "res_previous": "Previous",
      "res_problemWithSavedView": "Problem with saved view",
      "res_problemWithSavedViewMultipleColumnsText": "Your saved view named \\{0}\\ contains {1} columns that are not available in the application. This could be due to an application update.",
      "res_problemWithSavedViewSingleColumnText": "Your saved view named \\{0}\\ contains column that is not available in the application. This could be due to an application update.",
      "res_propertyId": "Property ID",
      "res_remove": "Remove",
      "res_removeConflictingColumnText": "This will remove conflicting column from your saved view. Continue?",
      "res_removeConflictingColumnsText": "This will remove {0} conflicting columns from your saved view. Continue?",
      "res_replaceYourCurrentColumnConfiguration": "Replace your current column configuration?",
      "res_resetColumns": "Reset Columns",
      "res_saveAndClose": "Save and close",
      "res_saveView": "Save view",
      "res_search": "Search",
      "res_selectAll": "Select All",
      "res_selectAView": "Select a view",
      "res_selectFixProblemText": "Select Fix Problem to remove the missing columns from your saved view.",
      "res_selectTheCurrentOption": "Select the current option",
      "res_send": "Send",
      "res_sendErrorReport": "Send Error Report",
      "res_today": "Today",
      "res_trace": "Trace",
      "res_undo": "Undo",
      "res_unknown": "unknown",
      "res_url": "url",
      "res_urlAllCaps": "URL",
      "res_userAgent": "User Agent",
      "res_viewColumnManagementPanelText": "View the column management panel to the right of this grid to view all available columns.",
      "res_viewErrorReport": "View Error Report",
      "res_yes": "Yes"
   },
   "bg": {
      "res_am": "АЗ",
      "res_anErrorHasOccurred": "Възникна грешка",
      "res_anErrorOccurredMessageLineOne": "Възникна грешка и заявката ви не може да бъде изпълнена.",
      "res_anErrorOccurredMessageLineTwo": "UniFocus създаде доклад за грешка, който можете да изпратите на нашия екип за отстраняване на неизправности, за да можем да предоставим по-добро обслужване в бъдеще.",
      "res_applicationId": "Идентификатор на приложението",
      "res_at": "В",
      "res_build": "Изграждане",
      "res_cancel": "Отмяна",
      "res_clickToSelectOrgLayer": "Щракнете, за да изберете орг. слой",
      "res_columns": "Колони",
      "res_columnsCannotBeLoaded": "Колоните не могат да бъдат заредени",
      "res_columnsCannotBeDisplayedSingleColumnText": "1 колона не е достъпна за показване във вашата мрежа. Това може да се дължи на актуализация на приложението.",
      "res_columnsCannotBeDisplayedMultipleColumnsText": "Колоните {0} не са достъпни за показване във вашата мрежа. Това може да се дължи на актуализация на приложението.",
      "res_collapseAll": "Свалете всички",
      "res_continue": "Продължи",
      "res_correlationId": "ИД на корелацията",
      "res_current": "Текущ",
      "res_databaseId": "ИД на база данни",
      "res_delete": "Изтриване",
      "res_deleteView": "Изтриване на изглед",
      "res_deleteViewText": "Това ще премахне окончателно запазения изглед от базата данни. Това действие не може да бъде отменено.",
      "res_deselectAll": "Премахнете отметката на всички",
      "res_doNothing": "Не правете нищо",
      "res_dontSend": "Не изпращай",
      "res_errorCode": "Код за грешка",
      "res_errorMessage": "Съобщение за грешка",
      "res_expandAll": "Разшири всички",
      "res_help": "Помощ",
      "res_fixProblem": "Отстраняване на проблема",
      "res_hideThisColumn": "Скриване на тази колона",
      "res_invalidInput": "Невалиден вход",
      "res_load": "Натоварване",
      "res_loadASavedView": "Зареждане на запазен изглед",
      "res_loadSaveViews": "Заредене/запазване на изгледи",
      "res_loadSelectedOrgLayer": "Зареждане на избрания орг. слой",
      "res_method": "Метод",
      "res_newViewName": "Ново име на изглед",
      "res_next": "Следваща",
      "res_no": "Не",
      "res_ok": "ДОБРЕ",
      "res_overwrite": "Презаписване",
      "res_overwriteExistingViewText": "Името, което сте избрали, вече съществува. Искате ли да презапишете съществуващия изглед?",
      "res_partnerCode": "Партньорски код",
      "res_pm": "СЛЕДОБЕД",
      "res_previous": "Предишна",
      "res_problemWithSavedView": "Проблем със запазения изглед",
      "res_problemWithSavedViewMultipleColumnsText": "Запазеният ви изглед, наречен\\ {0}\\, съдържа {1} колони, които не са налични в приложението. Това може да се дължи на актуализация на приложението.",
      "res_problemWithSavedViewSingleColumnText": "Запазеният ви изглед, наречен\\ {0}\\, съдържа колона, която не е налична в приложението. Това може да се дължи на актуализация на приложението.",
      "res_propertyId": "ИД на имота",
      "res_remove": "Премахване",
      "res_removeConflictingColumnText": "Това ще премахне противоречивата колона от запазения ви изглед. Продължаваш?",
      "res_removeConflictingColumnsText": "Това ще премахне {0} противоречиви колони от вашия запазен изглед. Продължаваш?",
      "res_replaceYourCurrentColumnConfiguration": "Заменете текущата си конфигурация на колоната?",
      "res_resetColumns": "Нулиране на колони",
      "res_saveAndClose": "Запазване и затваряне",
      "res_saveView": "Запазване на изглед",
      "res_search": "Търсене",
      "res_selectAll": "Избери всички",
      "res_selectAView": "Изберете изглед",
      "res_selectFixProblemText": "Изберете Отстраняване на проблем, за да премахнете липсващите колони от запазения изглед.",
      "res_selectTheCurrentOption": "Изберете текущата опция",
      "res_send": "Изпрати",
      "res_sendErrorReport": "Изпращане на доклад за грешка",
      "res_today": "Днес",
      "res_trace": "Проследяване",
      "res_undo": "Отмяна",
      "res_unknown": "неизвестен",
      "res_url": "URL адрес",
      "res_urlAllCaps": "URL АДРЕС",
      "res_userAgent": "Потребителски агент",
      "res_viewColumnManagementPanelText": "Прегледайте панела за управление на колони вдясно от тази мрежа, за да видите всички налични колони.",
      "res_viewErrorReport": "Преглед на доклада за грешка",
      "res_yes": "Да"
   },
   "de": {
      "res_am": "AM",
      "res_anErrorHasOccurred": "Es ist ein Fehler aufgetreten",
      "res_anErrorOccurredMessageLineOne": "Es ist ein Fehler aufgetreten, und Ihre Anforderung kann nicht abgeschlossen werden",
      "res_anErrorOccurredMessageLineTwo": "UniFocus hat einen Fehlerbericht erstellt, den Sie an unser Fehlerbehebungsteam senden können, damit wir Ihnen in Zukunft einen besseren Service bieten können.",
      "res_applicationId": "Anwendung Id",
      "res_at": "Bei",
      "res_build": "Bauen",
      "res_cancel": "Abbrechen",
      "res_clickToSelectOrgLayer": "Klicken Sie hier, um eine Organisationsebene auszuwählen",
      "res_columns": "Spalten",
      "res_columnsCannotBeLoaded": "Spalten können nicht geladen werden",
      "res_columnsCannotBeDisplayedSingleColumnText": "1 Spalte ist nicht verfügbar, um in Ihrem Raster angezeigt zu werden. Dies kann auf eine Anwendungsaktualisierung zurückzuführen sein",
      "res_columnsCannotBeDisplayedMultipleColumnsText": "{0}  sind nicht für die Anzeige im Raster verfügbar. Dies kann auf eine Anwendungsaktualisierung zurückzuführen sein",
      "res_collapseAll": "Alle reduzieren",
      "res_continue": "Fortfahren",
      "res_correlationId": "Korrelation ID",
      "res_current": "Aktuell",
      "res_databaseId": "Datenbank-ID",
      "res_delete": "Löschen",
      "res_deleteView": "Ansicht löschen",
      "res_deleteViewText": "Dadurch wird die gespeicherte Ansicht dauerhaft aus der Datenbank entfernt. Diese Aktion kann nicht rückgängig gemacht werden",
      "res_deselectAll": "Alle abwählen",
      "res_doNothing": "Nichts tun",
      "res_dontSend": "Nicht senden",
      "res_errorCode": "Fehler Code",
      "res_errorMessage": "Fehlermeldung",
      "res_expandAll": "Alle erweitern",
      "res_help": "Hilfe",
      "res_fixProblem": "Problem beheben",
      "res_hideThisColumn": "Diese Kolumne ausblenden",
      "res_invalidInput": "Ungültige Eingabe",
      "res_load": "Laden",
      "res_loadASavedView": "Eine gespeicherte Ansicht laden",
      "res_loadSaveViews": "Ansichten laden / speichern",
      "res_loadSelectedOrgLayer": "Ausgewählte Org. Ebene laden",
      "res_method": "Methode",
      "res_newViewName": "Name der neuen Ansicht",
      "res_next": "Weiter",
      "res_no": "Nein",
      "res_ok": "OK",
      "res_overwrite": "Überschreiben",
      "res_overwriteExistingViewText": "Der ausgewählte Name existiert bereits. Möchten Sie die vorhandene Ansicht überschreiben?",
      "res_partnerCode": "Partner Code",
      "res_pm": "PM",
      "res_previous": "Vorherige",
      "res_problemWithSavedView": "Problem mit gespeicherter Ansicht",
      "res_problemWithSavedViewMultipleColumnsText": "Ihre gespeicherte Ansicht namens {0} enthält {1} Spalten, die in der Anwendung nicht verfügbar sind. Dies könnte auf eine Aktualisierung der Anwendung zurückzuführen sein.",
      "res_problemWithSavedViewSingleColumnText": "Ihre gespeicherte Ansicht mit dem Namen {0} enthält eine Spalte, die in der Anwendung nicht verfügbar ist. Dies könnte auf eine Aktualisierung der Anwendung zurückzuführen sein.",
      "res_propertyId": "Eigenschafts-ID",
      "res_remove": "Entfernen Sie",
      "res_removeConflictingColumnText": "Dadurch wird die widersprüchliche Spalte aus Ihrer gespeicherten Ansicht entfernt. Weiter?",
      "res_removeConflictingColumnsText": "Dadurch werden {0} widersprüchliche Spalten aus Ihrer gespeicherten Ansicht entfernt. Weiter?",
      "res_replaceYourCurrentColumnConfiguration": "Aktuelle Spaltenkonfiguration ersetzen?",
      "res_resetColumns": "Spalten zurücksetzen",
      "res_saveAndClose": "Speichern und schließen",
      "res_saveView": "Ansicht speichern",
      "res_search": "Suche",
      "res_selectAll": "Alle auswählen",
      "res_selectAView": "Ansicht auswählen",
      "res_selectFixProblemText": "Wählen Sie Problem beheben, um die fehlenden Spalten aus der gespeicherten Ansicht zu entfernen",
      "res_selectTheCurrentOption": "Aktuelle Option auswählen",
      "res_send": "Senden",
      "res_sendErrorReport": "Fehlerbericht senden",
      "res_today": "Heute",
      "res_trace": "Spur",
      "res_undo": "Rückgängig machen",
      "res_unknown": "Unbekannt",
      "res_url": "url",
      "res_urlAllCaps": "URL",
      "res_userAgent": "Benutzer-Agent",
      "res_viewColumnManagementPanelText": "Zeigen Sie das Spaltenverwaltungsfenster rechts neben diesem Raster an, um alle verfügbaren Spalten anzuzeige",
      "res_viewErrorReport": "Fehlerbericht anzeigen",
      "res_yes": "Ja"
   },
   "el": {
      "res_am": "ΕΊΜΑΙ",
      "res_anErrorHasOccurred": "Παρουσιάστηκε σφάλμα",
      "res_anErrorOccurredMessageLineOne": "Παρουσιάστηκε σφάλμα και το αίτημά σας δεν μπορεί να ολοκληρωθεί.",
      "res_anErrorOccurredMessageLineTwo": "Η UniFocus δημιούργησε μια αναφορά σφάλματος που μπορείτε να στείλετε στην ομάδα αντιμετώπισης προβλημάτων, ώστε να μπορούμε να παρέχουμε καλύτερες υπηρεσίες στο μέλλον.",
      "res_applicationId": "Αναγνωριστικό εφαρμογής",
      "res_at": "Στο",
      "res_build": "Φτιάξτε",
      "res_cancel": "Ακύρωση",
      "res_clickToSelectOrgLayer": "Κάντε κλικ για να επιλέξετε ένα επίπεδο οργάνου",
      "res_columns": "Στήλες",
      "res_columnsCannotBeLoaded": "Δεν είναι δυνατή η φόρτωση των στηλών",
      "res_columnsCannotBeDisplayedSingleColumnText": "1 στήλη δεν είναι διαθέσιμη για εμφάνιση στο πλέγμα σας. Αυτό μπορεί να οφείλεται σε ενημέρωση εφαρμογής.",
      "res_columnsCannotBeDisplayedMultipleColumnsText": "Οι στήλες {0} δεν είναι διαθέσιμες για εμφάνιση στο πλέγμα σας. Αυτό μπορεί να οφείλεται σε ενημέρωση εφαρμογής.",
      "res_collapseAll": "Σύνταξη όλων",
      "res_continue": "Συνέχισε",
      "res_correlationId": "Ταυτότητα συσχέτισης",
      "res_current": "Τρέχουσα",
      "res_databaseId": "Αναγνωριστικό βάσης",
      "res_delete": "Διαγραφή",
      "res_deleteView": "Διαγραφή προβολής",
      "res_deleteViewText": "Αυτό θα καταργήσει οριστικά την αποθηκευμένη προβολή από τη βάση δεδομένων. Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.",
      "res_deselectAll": "Κατάργηση επιλογής όλων",
      "res_doNothing": "Μην κάνεις τίποτα",
      "res_dontSend": "Μην στέλνετε",
      "res_errorCode": "Κωδικός σφάλματος",
      "res_errorMessage": "Μήνυμα λάθους",
      "res_expandAll": "Αναπτύξτε όλα",
      "res_help": "Βοήθεια",
      "res_fixProblem": "Επιδιόρθωση προβλήματος",
      "res_hideThisColumn": "Απόκρυψη αυτής της στήλης",
      "res_invalidInput": "Μη έγκυρη είσοδος",
      "res_load": "Φορτίο",
      "res_loadASavedView": "Φόρτωση αποθηκευμένης προβολής",
      "res_loadSaveViews": "Φόρτωση/αποθήκευση προβολών",
      "res_loadSelectedOrgLayer": "Φόρτωση επιλεγμένου επιπέδου Οργάνωσης",
      "res_method": "Μέθοδος",
      "res_newViewName": "Νέο όνομα προβολής",
      "res_next": "Επόμενο",
      "res_no": "Οχι",
      "res_ok": "ΕΝΤΆΞΕΙ.",
      "res_overwrite": "Αντικατάσταση",
      "res_overwriteExistingViewText": "Το όνομα που επιλέξατε υπάρχει ήδη. Θέλετε να αντικαταστήσετε την υπάρχουσα προβολή;",
      "res_partnerCode": "Κωδικός Συνεργάτη",
      "res_pm": "ΜΜ",
      "res_previous": "Προηγούμενο",
      "res_problemWithSavedView": "Πρόβλημα με την αποθηκευμένη προβολή",
      "res_problemWithSavedViewMultipleColumnsText": "Η αποθηκευμένη προβολή που ονομάζεται\\ {0}\\ περιέχει {1} στήλες που δεν είναι διαθέσιμες στην εφαρμογή. Αυτό μπορεί να οφείλεται σε ενημέρωση εφαρμογής.",
      "res_problemWithSavedViewSingleColumnText": "Η αποθηκευμένη προβολή που ονομάζεται\\ {0}\\ περιέχει στήλη που δεν είναι διαθέσιμη στην εφαρμογή. Αυτό μπορεί να οφείλεται σε ενημέρωση εφαρμογής.",
      "res_propertyId": "Κωδικός Ακινήτου",
      "res_remove": "Αφαιρέστε",
      "res_removeConflictingColumnText": "Αυτό θα καταργήσει την αντικρουόμενη στήλη από την αποθηκευμένη προβολή σας. Συνέχεια;",
      "res_removeConflictingColumnsText": "Αυτό θα αφαιρέσει {0} αντικρουόμενες στήλες από την αποθηκευμένη προβολή σας. Συνέχεια;",
      "res_replaceYourCurrentColumnConfiguration": "Αντικαταστήστε την τρέχουσα διαμόρφωση στήλης;",
      "res_resetColumns": "Επαναφορά στηλών",
      "res_saveAndClose": "Αποθήκευση και κλείσιμο",
      "res_saveView": "Αποθήκευση προβολής",
      "res_search": "Αναζήτηση",
      "res_selectAll": "Επιλογή όλων",
      "res_selectAView": "Επιλογή προβολής",
      "res_selectFixProblemText": "Επιλέξτε Επιδιόρθωση προβλήματος για να καταργήσετε τις στήλες που λείπουν από την αποθηκευμένη προβολή σας.",
      "res_selectTheCurrentOption": "Επιλέξτε την τρέχουσα επιλογή",
      "res_send": "Αποστολή",
      "res_sendErrorReport": "Αποστολή αναφοράς σφάλματος",
      "res_today": "ΣΗΜΕΡΑ",
      "res_trace": "Ίχνη",
      "res_undo": "Αναίρεση",
      "res_unknown": "άγνωστο",
      "res_url": "διεύθυνση URL",
      "res_urlAllCaps": "URL",
      "res_userAgent": "Πράκτορας χρήστη",
      "res_viewColumnManagementPanelText": "Δείτε τον πίνακα διαχείρισης στηλών στα δεξιά αυτού του πλέγματος για να δείτε όλες τις διαθέσιμες στήλες.",
      "res_viewErrorReport": "Προβολή αναφοράς σφάλματος",
      "res_yes": "Ναί"
   },
   "es": {
      "res_am": "AM",
      "res_anErrorHasOccurred": "Se ha producido un error",
      "res_anErrorOccurredMessageLineOne": "Ocurrió un error y la solicitud no puede ser completada.",
      "res_anErrorOccurredMessageLineTwo": "UniFocus ha creado un informe de errores que puedes enviar a nuestro equipo de solución de problemas, para que podamos ofrecer un mejor servicio en el futuro.",
      "res_applicationId": "ID de aplicación",
      "res_at": "En",
      "res_build": "Construir",
      "res_cancel": "Cancelar",
      "res_clickToSelectOrgLayer": "Haz clic para seleccionar una organización. capa",
      "res_columns": "Columnas",
      "res_columnsCannotBeLoaded": "Las columnas no se pueden cargar",
      "res_columnsCannotBeDisplayedSingleColumnText": "1 columna no está disponible para mostrarse en la cuadrícula. Esto podría deberse a una actualización de la aplicación.",
      "res_columnsCannotBeDisplayedMultipleColumnsText": "{0} columnas no están disponibles para mostrarse en la cuadrícula. Esto podría deberse a una actualización de la aplicación.",
      "res_collapseAll": "Contraer todos",
      "res_continue": "Continúe",
      "res_correlationId": "ID de correlación",
      "res_current": "Actual",
      "res_databaseId": "Identificación de la base de datos",
      "res_delete": "Borrar",
      "res_deleteView": "Borrar vista",
      "res_deleteViewText": "Esto eliminará permanentemente la vista guardada de la base de datos. Esta acción no se puede deshacer.",
      "res_deselectAll": "Deseleccionar todo",
      "res_doNothing": "Dejar sin hacer nada",
      "res_dontSend": "No enviar",
      "res_errorCode": "Código de error",
      "res_errorMessage": "Mensaje de error",
      "res_expandAll": "Expandir todos",
      "res_help": "Ayuda",
      "res_fixProblem": "Arreglar problema",
      "res_hideThisColumn": "Ocultar esta columna",
      "res_invalidInput": "Entrada inválida",
      "res_load": "Cargar",
      "res_loadASavedView": "Cargar una vista guardada",
      "res_loadSaveViews": "Cargar / Guardar vistas",
      "res_loadSelectedOrgLayer": "Cargar organización seleccionada. capa",
      "res_method": "Método",
      "res_newViewName": "Nuevo nombre de vista",
      "res_next": "Siguiente",
      "res_no": "No",
      "res_ok": "OK",
      "res_overwrite": "Superponer",
      "res_overwriteExistingViewText": "El nombre que seleccionaste ya existe. ¿Deseas sobrescribir la vista existente?",
      "res_partnerCode": "Código de socio",
      "res_pm": "PM",
      "res_previous": "Anterior",
      "res_problemWithSavedView": "Problema con la vista guardada",
      "res_problemWithSavedViewMultipleColumnsText": "Tu vista guardada llamada {0} contiene {1} columnas que no están disponibles en la aplicación. Esto podría deberse a una actualización de la aplicación.",
      "res_problemWithSavedViewSingleColumnText": "Tu vista guardada llamada {0} contiene una columna que no está disponible en la aplicación. Esto podría deberse a una actualización de la aplicación.",
      "res_propertyId": "Id. de propiedad",
      "res_remove": "Eliminar",
      "res_removeConflictingColumnText": "Esto eliminará la columna en conflicto de la vista guardada. ¿Continuar?",
      "res_removeConflictingColumnsText": "Esto eliminará {0} columnas en conflicto de la vista guardada. ¿Continuar?",
      "res_replaceYourCurrentColumnConfiguration": "¿Reemplazar la configuración de columna actual?",
      "res_resetColumns": "Resetear Columnas",
      "res_saveAndClose": "Guardar y cerrar",
      "res_saveView": "Salvar vista",
      "res_search": "Buscar",
      "res_selectAll": "Seleccionar todo",
      "res_selectAView": "Selecciona una vista",
      "res_selectFixProblemText": "Selecciona Solucionar problema para eliminar las columnas que faltan de la vista guardada.",
      "res_selectTheCurrentOption": "Selecciona la opción actual",
      "res_send": "Enviar",
      "res_sendErrorReport": "Enviar reporte de error",
      "res_today": "Hoy",
      "res_trace": "Rastro",
      "res_undo": "Deshacer",
      "res_unknown": "Desconocida",
      "res_url": "URL",
      "res_urlAllCaps": "URL",
      "res_userAgent": "Agente de usuario",
      "res_viewColumnManagementPanelText": "Ve el panel de administración de columnas a la derecha de esta cuadrícula para ver todas las columnas disponibles.",
      "res_viewErrorReport": "Ver informe de errores",
      "res_yes": "Sí"
   },
   "fr": {
      "res_am": "AM",
      "res_anErrorHasOccurred": "Une erreur est survenue",
      "res_anErrorOccurredMessageLineOne": "Une erreur est survenue est votre demande ne peut être complete",
      "res_anErrorOccurredMessageLineTwo": "UniFocus a créé un rapport d'erreur que vous pouvez envoyer à notre équipe technique, afin que nous puissions fournir un meilleur service à l'avenir.",
      "res_applicationId": "ID de l'application",
      "res_at": "Sur",
      "res_build": "Construire",
      "res_cancel": "Annuler",
      "res_clickToSelectOrgLayer": "Cliquez pour sélectionner une couche d'org",
      "res_columns": "Colonnes",
      "res_columnsCannotBeLoaded": "Les colonnes ne peuvent pas être chargées",
      "res_columnsCannotBeDisplayedSingleColumnText": "1 colonne n'est pas disponible pour être affichée dans votre grille. Cela peut être dû à une mise à jour de l'application.",
      "res_columnsCannotBeDisplayedMultipleColumnsText": "les colonnes {0} ne sont pas disponibles pour être affichées dans votre grille. Cela peut être dû à une mise à jour de l'application.",
      "res_collapseAll": "Réduire tout",
      "res_continue": "Continuer",
      "res_correlationId": "ID de corrélation",
      "res_current": "En cours",
      "res_databaseId": "Numéro d'identification de la base de données",
      "res_delete": "Supprimer",
      "res_deleteView": "Supprimer la vue",
      "res_deleteViewText": "Cela supprimera définitivement la vue enregistrée de la base de données. Cette action ne peut pas être annulée.",
      "res_deselectAll": "Désélectionner tout",
      "res_doNothing": "Ne rien faire",
      "res_dontSend": "N'envoyez pas",
      "res_errorCode": "Code d'erreur",
      "res_errorMessage": "Message d'erreur",
      "res_expandAll": "Élargir tout",
      "res_help": "Aide",
      "res_fixProblem": "Régler le problème",
      "res_hideThisColumn": "Masquer cette colonne",
      "res_invalidInput": "Entrée non valable",
      "res_load": "Chargement",
      "res_loadASavedView": "Charger une vue enregistrée",
      "res_loadSaveViews": "Charger / Sauvegarder les vues",
      "res_loadSelectedOrgLayer": "Charger la couche Org. sélectionnée",
      "res_method": "Méthode",
      "res_newViewName": "Nom de la nouvelle vue",
      "res_next": "Suivant",
      "res_no": "Non",
      "res_ok": "OK",
      "res_overwrite": "Recouvrir",
      "res_overwriteExistingViewText": "le non que vous avez choisi existe déjà. Voiles vous recouvrir la nouvelle vue",
      "res_partnerCode": "Code du Partenaire",
      "res_pm": "PM",
      "res_previous": "Précédent",
      "res_problemWithSavedView": "Problème avec la vue sauvegardée",
      "res_problemWithSavedViewMultipleColumnsText": "Votre vue enregistrée nommée {0} contient des colonnes {1} qui ne sont pas disponibles dans l'application. Cela peut être dû à une mise à jour de l'application.",
      "res_problemWithSavedViewSingleColumnText": "Votre vue enregistrée nommée {0} contient une colonne qui n'est pas disponible dans l'application. Cela pourrait être dû à une mise à jour de l'application.",
      "res_propertyId": "Numéro d'identification de l’établissement :",
      "res_remove": "Retirer",
      "res_removeConflictingColumnText": "Cela supprimera la colonne en conflit de votre vue sauvegardée. Continuer ?",
      "res_removeConflictingColumnsText": "Cela supprimera {0} les colonnes en conflit de votre vue enregistrée. Continuer ?",
      "res_replaceYourCurrentColumnConfiguration": "Remplacer la configuration actuelle des colonnes",
      "res_resetColumns": "Réinitialiser les colonnes",
      "res_saveAndClose": "\\ Enregistrer et fermer",
      "res_saveView": "Enregistrer l'affichage",
      "res_search": "chercher",
      "res_selectAll": "Sélectionner tout",
      "res_selectAView": "Sélectionnez l'affichage",
      "res_selectFixProblemText": "Sélectionnez Fixer le problème pour supprimer les colonnes manquantes de votre vue enregistrée.",
      "res_selectTheCurrentOption": "Sélectionnez l'option actuelle",
      "res_send": "Envoyer",
      "res_sendErrorReport": "Envoyer le rapport d'erreur",
      "res_today": "Aujourd'hui",
      "res_trace": "Trace",
      "res_undo": "Annuler",
      "res_unknown": "Inconnu",
      "res_urlAllCaps": "URL",
      "res_userAgent": "Agent utilisateur",
      "res_viewColumnManagementPanelText": "Consultez le panneau de gestion des colonnes à droite de cette grille pour voir toutes les colonnes disponibles.",
      "res_viewErrorReport": "Afficher le rapport d'erreur",
      "res_yes": "Oui",
      "res_url": "url"
   },
   "fr-CA": {
      "res_am": "JE SUIS",
      "res_anErrorHasOccurred": "Une erreur s'est produite",
      "res_anErrorOccurredMessageLineOne": "Une erreur s'est produite et votre demande ne peut pas être traitée.",
      "res_anErrorOccurredMessageLineTwo": "UniFocus a créé un rapport d'erreur que vous pouvez envoyer à notre équipe de dépannage, afin que nous puissions fournir un meilleur service à l'avenir.",
      "res_applicationId": "Identifiant de la demande",
      "res_at": "À",
      "res_build": "Construire",
      "res_cancel": "Annuler",
      "res_clickToSelectOrgLayer": "Cliquez pour sélectionner une couche org.",
      "res_columns": "Colonnes",
      "res_columnsCannotBeLoaded": "Les colonnes ne peuvent pas être chargées",
      "res_columnsCannotBeDisplayedSingleColumnText": "Une colonne n'est pas disponible pour être affichée dans votre grille. Cela pourrait être dû à une mise à jour de l'application.",
      "res_columnsCannotBeDisplayedMultipleColumnsText": "Les colonnes {0} ne peuvent pas être affichées dans votre grille. Cela pourrait être dû à une mise à jour de l'application.",
      "res_collapseAll": "Tout effondre",
      "res_continue": "Continuer",
      "res_correlationId": "ID de corrélation",
      "res_current": "Actuel",
      "res_databaseId": "ID de base de données",
      "res_delete": "Supprimer",
      "res_deleteView": "Supprimer la vue",
      "res_deleteViewText": "Cela supprimera définitivement la vue enregistrée de la base de données. Cette action ne peut pas être invalidée.",
      "res_deselectAll": "Désélectionner tout",
      "res_doNothing": "Ne rien faire",
      "res_dontSend": "Ne pas envoyer",
      "res_errorCode": "Code d'erreur",
      "res_errorMessage": "Message d'erreur",
      "res_expandAll": "Élargir tout",
      "res_help": "Aide",
      "res_fixProblem": "Corriger le problème",
      "res_hideThisColumn": "Masquer cette colonne",
      "res_invalidInput": "Entrée non valide",
      "res_load": "Charge",
      "res_loadASavedView": "Charger une vue enregistrée",
      "res_loadSaveViews": "Charger ou enregistrer des vues",
      "res_loadSelectedOrgLayer": "Charger la couche Org. sélectionnée",
      "res_method": "Méthode",
      "res_newViewName": "Nouveau nom de la vue",
      "res_next": "Prochaine",
      "res_no": "Non",
      "res_ok": "OK",
      "res_overwrite": "Rempasser",
      "res_overwriteExistingViewText": "Le nom que vous avez sélectionné existe déjà. Voulez-vous remplacer la vue existante ?",
      "res_partnerCode": "Code de partenaire",
      "res_pm": "PM",
      "res_previous": "Précédent",
      "res_problemWithSavedView": "Problème avec la vue enregistrée",
      "res_problemWithSavedViewMultipleColumnsText": "La vue enregistrée nommée \\ {0} \\ contient {1} colonnes qui ne sont pas disponibles dans l'application. Cela pourrait être dû à une mise à jour de l'application.",
      "res_problemWithSavedViewSingleColumnText": "La vue enregistrée nommée \\ {0} \\ contient une colonne qui n'est pas disponible dans l'application. Cela pourrait être dû à une mise à jour de l'application.",
      "res_propertyId": "Identifiant de la propriété",
      "res_remove": "Supprimer",
      "res_removeConflictingColumnText": "Cela supprimera les colonnes conflictuelles de la vue enregistrée. Continuer ?",
      "res_removeConflictingColumnsText": "Cela supprimera {0} colonnes en conflit de la vue enregistrée. Continuer ?",
      "res_replaceYourCurrentColumnConfiguration": "Remplacer votre configuration de colonne actuelle ?",
      "res_resetColumns": "Réinitialiser les colonnes",
      "res_saveAndClose": "Enregistrer et fermer",
      "res_saveView": "Enregistrer la vue",
      "res_search": "Chercher",
      "res_selectAll": "Sélectionner tout",
      "res_selectAView": "Sélectionner une vue",
      "res_selectFixProblemText": "Sélectionnez Corriger le problème pour supprimer les colonnes manquantes de la vue enregistrée.",
      "res_selectTheCurrentOption": "Sélectionnez l'option actuelle",
      "res_send": "Envoyer",
      "res_sendErrorReport": "Envoyer un rapport d'erreur",
      "res_today": "Aujourd'hui",
      "res_trace": "Tracer",
      "res_undo": "Défaire",
      "res_unknown": "inconnu",
      "res_url": "url",
      "res_urlAllCaps": "URL",
      "res_userAgent": "Agent utilisateur",
      "res_viewColumnManagementPanelText": "Affichez le panneau de gestion des colonnes à droite de cette grille pour afficher toutes les colonnes disponibles.",
      "res_viewErrorReport": "Afficher le rapport d'erreur",
      "res_yes": "Oui"
   },
   "hi": {
      "res_am": "हूँ",
      "res_anErrorHasOccurred": "एक त्रुटि हुई",
      "res_anErrorOccurredMessageLineOne": "एक त्रुटि हुई और आपका अनुरोध पूरा नहीं किया जा सका।",
      "res_anErrorOccurredMessageLineTwo": "UniFocus ने एक त्रुटि रिपोर्ट बनाई है जिसे आप हमारी समस्या निवारण टीम को भेज सकते हैं, ताकि हम भविष्य में बेहतर सेवा प्रदान कर सकें।",
      "res_applicationId": "ऐप्लिकेशन आईडी",
      "res_at": "पर",
      "res_build": "बिल्ड करें",
      "res_cancel": "कैंसिल करें",
      "res_clickToSelectOrgLayer": "ऑर्ग लेयर चुनने के लिए क्लिक करें",
      "res_columns": "कॉलम",
      "res_columnsCannotBeLoaded": "कॉलम लोड नहीं किए जा सकते",
      "res_columnsCannotBeDisplayedSingleColumnText": "आपके ग्रिड में प्रदर्शित होने के लिए 1 कॉलम उपलब्ध नहीं है। यह एप्लिकेशन अपडेट के कारण हो सकता है।",
      "res_columnsCannotBeDisplayedMultipleColumnsText": "{0} कॉलम आपके ग्रिड में प्रदर्शित होने के लिए उपलब्ध नहीं हैं। यह एप्लिकेशन अपडेट की वजह से हो सकता है।",
      "res_collapseAll": "सभी को संकुचित करें",
      "res_continue": "जारी रखें",
      "res_correlationId": "सहसंबंध आईडी",
      "res_current": "मौज़ूदा",
      "res_databaseId": "डेटाबेस आईडी",
      "res_delete": "मिटाएँ",
      "res_deleteView": "दृश्य मिटाएँ",
      "res_deleteViewText": "यह डेटाबेस से सहेजे गए दृश्य को स्थायी रूप से हटा देगा। इस क्रिया को पूर्ववत नहीं किया जा सकता।",
      "res_deselectAll": "सभी का चयन रद्द करें",
      "res_doNothing": "कुछ न करें",
      "res_dontSend": "मत भेजो",
      "res_errorCode": "त्रुटि कोड",
      "res_errorMessage": "त्रुटि संदेश",
      "res_expandAll": "सभी का विस्तार करें",
      "res_help": "मदद",
      "res_fixProblem": "समस्या ठीक करें",
      "res_hideThisColumn": "इस कॉलम को छुपाएं",
      "res_invalidInput": "अमान्य इनपुट",
      "res_load": "लोड",
      "res_loadASavedView": "सहेजा गया दृश्य लोड करें",
      "res_loadSaveViews": "दृश्य लोड करें/सहेजें",
      "res_loadSelectedOrgLayer": "चयनित ऑर्ग लेयर लोड करें",
      "res_method": "मेथड",
      "res_newViewName": "नया दृश्य नाम",
      "res_next": "अगला",
      "res_no": "नहीं",
      "res_ok": "ठीक है",
      "res_overwrite": "मिटाकर लिखें",
      "res_overwriteExistingViewText": "आपके द्वारा चुना गया नाम पहले से मौजूद है। क्या आप मौजूदा दृश्य को मिटाकर लिखना चाहते हैं?",
      "res_partnerCode": "पार्टनर कोड",
      "res_pm": "दोपहर",
      "res_previous": "पिछला",
      "res_problemWithSavedView": "सहेजे गए दृश्य के साथ समस्या",
      "res_problemWithSavedViewMultipleColumnsText": "\\ {0}\\ नाम के आपके सहेजे गए दृश्य में {1} कॉलम हैं जो एप्लिकेशन में उपलब्ध नहीं हैं। यह एप्लिकेशन अपडेट के कारण हो सकता है।",
      "res_problemWithSavedViewSingleColumnText": "\\ {0}\\ नाम के आपके सहेजे गए दृश्य में वह कॉलम है जो अनुप्रयोग में उपलब्ध नहीं है। यह एप्लिकेशन अपडेट के कारण हो सकता है।",
      "res_propertyId": "प्रॉपर्टी आईडी",
      "res_remove": "हटाएँ",
      "res_removeConflictingColumnText": "यह आपके सहेजे गए दृश्य से परस्पर विरोधी कॉलम को हटा देगा। जारी रखें?",
      "res_removeConflictingColumnsText": "यह आपके सहेजे गए दृश्य से {0} परस्पर विरोधी कॉलम हटा देगा। जारी रखें?",
      "res_replaceYourCurrentColumnConfiguration": "अपने मौजूदा कॉलम कॉन्फ़िगरेशन को बदलें?",
      "res_resetColumns": "कॉलम रीसेट करें",
      "res_saveAndClose": "सहेजें और बंद करें",
      "res_saveView": "दृश्य सहेजें",
      "res_search": "सर्च करें",
      "res_selectAll": "सभी का चयन करें",
      "res_selectAView": "एक दृश्य चुनें",
      "res_selectFixProblemText": "अपने सहेजे गए दृश्य से गुम कॉलम को निकालने के लिए समस्या ठीक करें का चयन करें।",
      "res_selectTheCurrentOption": "मौज़ूदा विकल्प चुनें",
      "res_send": "भेजें",
      "res_sendErrorReport": "त्रुटि रिपोर्ट भेजें",
      "res_today": "टुडे",
      "res_trace": "ट्रेस",
      "res_undo": "पहले जैसा करें",
      "res_unknown": "अनजान",
      "res_url": "यूआरएल",
      "res_urlAllCaps": "यूआरएल",
      "res_userAgent": "यूज़र एजेंट",
      "res_viewColumnManagementPanelText": "सभी उपलब्ध कॉलम देखने के लिए इस ग्रिड के दाईं ओर कॉलम प्रबंधन पैनल देखें।",
      "res_viewErrorReport": "त्रुटि रिपोर्ट देखें",
      "res_yes": "हाँ"
   },
   "ht": {
      "res_am": "AM",
      "res_anErrorHasOccurred": "Yon erè ki te fèt",
      "res_anErrorOccurredMessageLineOne": "Yon erè ki te fèt epi demann ou pa ka ranpli.",
      "res_anErrorOccurredMessageLineTwo": "UniFocus te kreye yon rapò erè ou ka voye bay ekip depanaj nou an, pou ke nou ka bay pi bon sèvis nan tan kap vini an.",
      "res_applicationId": "Id aplikasyon",
      "res_at": "Nan",
      "res_build": "Konstwi",
      "res_cancel": "Anile",
      "res_clickToSelectOrgLayer": "Klike pou chwazi yon org. kouch",
      "res_columns": "Kolòn",
      "res_columnsCannotBeLoaded": "Kolòn pa ka chaje",
      "res_columnsCannotBeDisplayedSingleColumnText": "1 kolòn pa disponib pou yo dwe parèt nan kadriyaj ou. Sa a ta ka akòz yon aktyalizasyon aplikasyon.",
      "res_columnsCannotBeDisplayedMultipleColumnsText": "{0} kolòn yo pa disponib pou yo dwe parèt nan kadriyaj ou. Sa a ta ka akòz yon aktyalizasyon aplikasyon.",
      "res_collapseAll": "Efondreman Tout",
      "res_continue": "Kontinye",
      "res_correlationId": "ID korelasyon",
      "res_current": "Kouran",
      "res_databaseId": "Idantite baz done",
      "res_delete": "Efase",
      "res_deleteView": "Efase View",
      "res_deleteViewText": "Sa a pral pou tout tan retire gade nan sove nan baz done a. Aksyon sa a pa ka defile.",
      "res_deselectAll": "Dezeleksyon tout",
      "res_doNothing": "Pa fè anyen",
      "res_dontSend": "Pa voye",
      "res_errorCode": "Kòd Erè",
      "res_errorMessage": "Mesaj Erè",
      "res_expandAll": "Elaji Tout",
      "res_help": "Ede",
      "res_fixProblem": "Ranje pwoblèm",
      "res_hideThisColumn": "Kache kolòn sa a",
      "res_invalidInput": "Antre envalid",
      "res_load": "Chaj",
      "res_loadASavedView": "Chaje yon View sove",
      "res_loadSaveViews": "Chaj/Sove opinyon",
      "res_loadSelectedOrgLayer": "Chaj chwazi org. kouch",
      "res_method": "Metòd",
      "res_newViewName": "Nouvo non View",
      "res_next": "Pwochen",
      "res_no": "Non",
      "res_ok": "OK",
      "res_overwrite": "Remplacé",
      "res_overwriteExistingViewText": "Non ou chwazi deja egziste. Èske ou vle remplacé View ki deja egziste a?",
      "res_partnerCode": "Kòd Patnè",
      "res_pm": "PM",
      "res_previous": "Anvan",
      "res_problemWithSavedView": "Pwoblèm ak gade sove",
      "res_problemWithSavedViewMultipleColumnsText": "View sove ou yo te rele\\ {0}\\ gen {1} kolòn ki pa disponib nan aplikasyon an. Sa a ta ka akòz yon aktyalizasyon aplikasyon.",
      "res_problemWithSavedViewSingleColumnText": "View sove ou yo te rele\\ {0}\\ gen kolòn ki pa disponib nan aplikasyon an. Sa a ta ka akòz yon aktyalizasyon aplikasyon.",
      "res_propertyId": "ID pwopriyete",
      "res_remove": "Retire",
      "res_removeConflictingColumnText": "Sa a pral retire kolòn konfli nan vi sove ou. Kontinye?",
      "res_removeConflictingColumnsText": "Sa a pral retire {0} kolòn konfli nan vi sove ou. Kontinye?",
      "res_replaceYourCurrentColumnConfiguration": "Ranplase konfigirasyon aktyèl kolòn ou?",
      "res_resetColumns": "Reyajiste Kolòn",
      "res_saveAndClose": "Sove epi fèmen",
      "res_saveView": "Sove View",
      "res_search": "Rechèch",
      "res_selectAll": "Chwazi tout",
      "res_selectAView": "Chwazi yon View",
      "res_selectFixProblemText": "Chwazi Ranje Pwoblèm yo retire kolòn yo ki manke nan gade sove ou.",
      "res_selectTheCurrentOption": "Chwazi opsyon aktyèl la",
      "res_send": "Voye",
      "res_sendErrorReport": "Voye Rapò Erè",
      "res_today": "Jodi a",
      "res_trace": "Trace",
      "res_undo": "Défonde",
      "res_unknown": "enkoni",
      "res_url": "Url",
      "res_urlAllCaps": "URL",
      "res_userAgent": "Ajan Itilizatè",
      "res_viewColumnManagementPanelText": "Gade panèl jesyon kolòn nan bò dwat la nan kadriyaj sa a pou wè tout kolòn ki disponib.",
      "res_viewErrorReport": "Gade Rapò Erè",
      "res_yes": "Wi"
   },
   "hu": {
      "res_am": "ÉN VAGYOK",
      "res_anErrorHasOccurred": "Hiba történt",
      "res_anErrorOccurredMessageLineOne": "Hiba történt, és a kérelem nem teljesíthető.",
      "res_anErrorOccurredMessageLineTwo": "Az UniFocus létrehozott egy hibajelentést, amelyet elküldhet hibaelhárító csapatunknak, hogy a jövőben jobb szolgáltatást nyújthassunk.",
      "res_applicationId": "Alkalmazás azonosítója",
      "res_at": "Itt",
      "res_build": "Építsen",
      "res_cancel": "Törölje",
      "res_clickToSelectOrgLayer": "Kattintson ide egy org. réteg kiválasztásához",
      "res_columns": "Oszlopok",
      "res_columnsCannotBeLoaded": "Az oszlopok nem tölthetők be",
      "res_columnsCannotBeDisplayedSingleColumnText": "Az 1 oszlop nem jeleníthető meg a rácson. Ennek oka lehet az alkalmazás frissítése.",
      "res_columnsCannotBeDisplayedMultipleColumnsText": "A {0} oszlopok nem jeleníthetők meg a rácson. Ennek oka lehet az alkalmazás frissítése.",
      "res_collapseAll": "Összecsukja az egészet",
      "res_continue": "Folytatás",
      "res_correlationId": "Korrelációs azonosító",
      "res_current": "Jelenlegi",
      "res_databaseId": "Adatbázis azonosító",
      "res_delete": "Törölje",
      "res_deleteView": "Nézet törlése",
      "res_deleteViewText": "Ez véglegesen eltávolítja a mentett nézetet az adatbázisból. Ezt a műveletet nem lehet visszavonni.",
      "res_deselectAll": "Minden jelölés törlése",
      "res_doNothing": "Ne csinálj semmit",
      "res_dontSend": "Ne küldjön",
      "res_errorCode": "Hibakód",
      "res_errorMessage": "Hibaüzenet",
      "res_expandAll": "Összes kibontása",
      "res_help": "Segítség",
      "res_fixProblem": "Probléma javítása",
      "res_hideThisColumn": "Az oszlop elrejtése",
      "res_invalidInput": "Érvénytelen bemenet",
      "res_load": "Betöltés",
      "res_loadASavedView": "Mentett nézet betöltése",
      "res_loadSaveViews": "Nézetek betöltése/mentése",
      "res_loadSelectedOrgLayer": "Kijelölt Org. réteg betöltése",
      "res_method": "Módszer",
      "res_newViewName": "Új nézet neve",
      "res_next": "Következő",
      "res_no": "Nem",
      "res_ok": "RENDBEN",
      "res_overwrite": "Felülírja",
      "res_overwriteExistingViewText": "A kiválasztott név már létezik. Felülírni szeretné a meglévő nézetet?",
      "res_partnerCode": "Partnerkód",
      "res_pm": "DÉLUTÁN",
      "res_previous": "Előző",
      "res_problemWithSavedView": "Probléma a mentett nézettel",
      "res_problemWithSavedViewMultipleColumnsText": "Az\\ {0}\\ nevű mentett nézet olyan {1} oszlopokat tartalmaz, amelyek nem érhetők el az alkalmazásban. Ennek oka lehet az alkalmazás frissítése.",
      "res_problemWithSavedViewSingleColumnText": "Az\\ {0}\\ nevű mentett nézet olyan oszlopot tartalmaz, amely nem érhető el az alkalmazásban. Ennek oka lehet az alkalmazás frissítése.",
      "res_propertyId": "Ingatlan azonosító",
      "res_remove": "Távolítsa el",
      "res_removeConflictingColumnText": "Ez eltávolítja az ütköző oszlopot a mentett nézetből. Folytatni?",
      "res_removeConflictingColumnsText": "Ez eltávolítja az {0} ütköző oszlopokat a mentett nézetből. Folytatni?",
      "res_replaceYourCurrentColumnConfiguration": "Cserélje ki az aktuális oszlopkonfigurációt?",
      "res_resetColumns": "oszlopok visszaállítása",
      "res_saveAndClose": "Mentés és bezárás",
      "res_saveView": "Nézet mentése",
      "res_search": "Keresés",
      "res_selectAll": "Válassza ki az összes lehetőséget",
      "res_selectAView": "Nézet kiválasztása",
      "res_selectFixProblemText": "Válassza a Hiba javítása lehetőséget a hiányzó oszlopok eltávolításához a mentett nézetből.",
      "res_selectTheCurrentOption": "Válassza ki az aktuális opciót",
      "res_send": "Küldés",
      "res_sendErrorReport": "Hibabejelentés küldése",
      "res_today": "Ma",
      "res_trace": "Nyomvonal",
      "res_undo": "Visszavonás",
      "res_unknown": "ismeretlen",
      "res_url": "URL-cím",
      "res_urlAllCaps": "URL",
      "res_userAgent": "Felhasználói ügynök",
      "res_viewColumnManagementPanelText": "Az összes rendelkezésre álló oszlop megtekintéséhez megtekintheti a rács jobb oldalán található oszlopkezelő panelt.",
      "res_viewErrorReport": "Hibabejelentés megtekintése",
      "res_yes": "Igen"
   },
   "id": {
      "res_am": "SAYA",
      "res_anErrorHasOccurred": "Sebuah Kesalahan Telah Terjadi",
      "res_anErrorOccurredMessageLineOne": "Terjadi kesalahan dan permintaan Anda tidak dapat diselesaikan.",
      "res_anErrorOccurredMessageLineTwo": "UniFocus telah membuat laporan kesalahan yang dapat Anda kirim ke tim pemecahan masalah kami, sehingga kami dapat memberikan layanan yang lebih baik di masa mendatang.",
      "res_applicationId": "Id Aplikasi",
      "res_at": "Di",
      "res_build": "Membangun",
      "res_cancel": "Batalkan",
      "res_clickToSelectOrgLayer": "Klik untuk memilih org. layer",
      "res_columns": "Kolom",
      "res_columnsCannotBeLoaded": "Kolom tidak dapat dimuat",
      "res_columnsCannotBeDisplayedSingleColumnText": "1 kolom tidak tersedia untuk ditampilkan di grid Anda. Ini bisa jadi karena pembaruan aplikasi.",
      "res_columnsCannotBeDisplayedMultipleColumnsText": "{0} kolom tidak tersedia untuk ditampilkan di grid Anda. Ini bisa jadi karena pembaruan aplikasi.",
      "res_collapseAll": "Tutup Semua",
      "res_continue": "Lanjutkan",
      "res_correlationId": "ID korelasi",
      "res_current": "Saat ini",
      "res_databaseId": "ID Basis Data",
      "res_delete": "Hapus",
      "res_deleteView": "Hapus tampilan",
      "res_deleteViewText": "Ini akan menghapus tampilan yang disimpan secara permanen dari database. Tindakan ini tidak dapat dibatalkan.",
      "res_deselectAll": "Batalkan Pilihan Semua",
      "res_doNothing": "Jangan lakukan apa-apa",
      "res_dontSend": "Jangan kirim",
      "res_errorCode": "Kode Kesalahan",
      "res_errorMessage": "Pesan Kesalahan",
      "res_expandAll": "Perluas Semua",
      "res_help": "Bantuan",
      "res_fixProblem": "Perbaiki Masalah",
      "res_hideThisColumn": "Sembunyikan Kolom Ini",
      "res_invalidInput": "Masukan tidak valid",
      "res_load": "Beban",
      "res_loadASavedView": "Memuat tampilan yang disimpan",
      "res_loadSaveViews": "Muat/ Simpan Tampilan",
      "res_loadSelectedOrgLayer": "Muat lapisan Org. yang dipilih",
      "res_method": "Metode",
      "res_newViewName": "Nama tampilan baru",
      "res_next": "Berikutnya",
      "res_no": "Tidak",
      "res_ok": "BAIK",
      "res_overwrite": "Tulis ulang",
      "res_overwriteExistingViewText": "Nama yang Anda pilih sudah ada. Apakah Anda ingin mengganti tampilan yang ada?",
      "res_partnerCode": "Kode Mitra",
      "res_pm": "SORE",
      "res_previous": "Sebelumnya",
      "res_problemWithSavedView": "Masalah dengan tampilan yang disimpan",
      "res_problemWithSavedViewMultipleColumnsText": "Tampilan tersimpan Anda bernama\\ {0}\\ berisi {1} kolom yang tidak tersedia di aplikasi. Ini bisa jadi karena pembaruan aplikasi.",
      "res_problemWithSavedViewSingleColumnText": "Tampilan tersimpan Anda bernama\\ {0}\\ berisi kolom yang tidak tersedia di aplikasi. Ini bisa jadi karena pembaruan aplikasi.",
      "res_propertyId": "ID Properti",
      "res_remove": "Hapus",
      "res_removeConflictingColumnText": "Ini akan menghapus kolom yang saling bertentangan dari tampilan yang disimpan. Lanjutkan?",
      "res_removeConflictingColumnsText": "Ini akan menghapus {0} kolom yang saling bertentangan dari tampilan yang disimpan. Lanjutkan?",
      "res_replaceYourCurrentColumnConfiguration": "Ganti konfigurasi kolom Anda saat ini?",
      "res_resetColumns": "Reset Kolom",
      "res_saveAndClose": "Simpan dan tutup",
      "res_saveView": "Simpan tampilan",
      "res_search": "Cari",
      "res_selectAll": "Pilih Semua",
      "res_selectAView": "Pilih tampilan",
      "res_selectFixProblemText": "Pilih Perbaiki Masalah untuk menghapus kolom yang hilang dari tampilan yang disimpan.",
      "res_selectTheCurrentOption": "Pilih opsi saat ini",
      "res_send": "Kirim",
      "res_sendErrorReport": "Kirim Laporan Kesalahan",
      "res_today": "Hari ini",
      "res_trace": "Jejak",
      "res_undo": "Batalkan",
      "res_unknown": "tidak diketahui",
      "res_url": "url",
      "res_urlAllCaps": "URL",
      "res_userAgent": "Agen Pengguna",
      "res_viewColumnManagementPanelText": "Lihat panel manajemen kolom di sebelah kanan kisi ini untuk melihat semua kolom yang tersedia.",
      "res_viewErrorReport": "Lihat Laporan Kesalahan",
      "res_yes": "ya"
   },
   "it": {
      "res_am": "SONO",
      "res_anErrorHasOccurred": "Si è verificato un errore",
      "res_anErrorOccurredMessageLineOne": "Si è verificato un errore e la tua richiesta non può essere completata.",
      "res_anErrorOccurredMessageLineTwo": "UniFocus ha creato una segnalazione di errore che puoi inviare al nostro team di risoluzione dei problemi, in modo da poter fornire un servizio migliore in futuro.",
      "res_applicationId": "ID applicazione",
      "res_at": "A",
      "res_build": "Costruisci",
      "res_cancel": "Annulla",
      "res_clickToSelectOrgLayer": "Fate clic per selezionare un livello dell'organizzazione.",
      "res_columns": "Colonne",
      "res_columnsCannotBeLoaded": "Le colonne non possono essere caricate",
      "res_columnsCannotBeDisplayedSingleColumnText": "1 colonna non è disponibile per essere visualizzata nella griglia. Ciò potrebbe essere dovuto a un aggiornamento dell'applicazione.",
      "res_columnsCannotBeDisplayedMultipleColumnsText": "Le colonne {0} non sono disponibili per essere visualizzate nella griglia. Ciò potrebbe essere dovuto a un aggiornamento dell'applicazione.",
      "res_collapseAll": "Comprimi tutto",
      "res_continue": "Continua",
      "res_correlationId": "ID di correlazione",
      "res_current": "Corrente",
      "res_databaseId": "ID del database",
      "res_delete": "Elimina",
      "res_deleteView": "Elimina visualizzazione",
      "res_deleteViewText": "Ciò rimuoverà definitivamente la vista salvata dal database. Questa azione non può essere annullata.",
      "res_deselectAll": "Deseleziona tutto",
      "res_doNothing": "Non fare niente",
      "res_dontSend": "Non inviare",
      "res_errorCode": "Codice di errore",
      "res_errorMessage": "Messaggio di errore",
      "res_expandAll": "Espandi tutto",
      "res_help": "Aiuto",
      "res_fixProblem": "Risolvi il problema",
      "res_hideThisColumn": "Nascondi questa colonna",
      "res_invalidInput": "Input non valido",
      "res_load": "Caricare",
      "res_loadASavedView": "Carica una vista salvata",
      "res_loadSaveViews": "Carica/salva visualizzazioni",
      "res_loadSelectedOrgLayer": "Carica il layer Org. selezionato",
      "res_method": "Metodo",
      "res_newViewName": "Nuovo nome della vista",
      "res_next": "Prossimo",
      "res_no": "No",
      "res_ok": "OK",
      "res_overwrite": "sovrascrivi",
      "res_overwriteExistingViewText": "Il nome selezionato esiste già. Vuoi sovrascrivere la vista esistente?",
      "res_partnerCode": "Codice partner",
      "res_pm": "PM",
      "res_previous": "Precedente",
      "res_problemWithSavedView": "Problema con la visualizzazione salvata",
      "res_problemWithSavedViewMultipleColumnsText": "La tua vista salvata denominata\\ {0}\\ contiene {1} colonne che non sono disponibili nell'applicazione. Ciò potrebbe essere dovuto a un aggiornamento dell'applicazione.",
      "res_problemWithSavedViewSingleColumnText": "La vista salvata denominata\\ {0}\\ contiene una colonna non disponibile nell'applicazione. Ciò potrebbe essere dovuto a un aggiornamento dell'applicazione.",
      "res_propertyId": "ID della proprietà",
      "res_remove": "Rimuovi",
      "res_removeConflictingColumnText": "Ciò rimuoverà la colonna in conflitto dalla visualizzazione salvata. Continuare?",
      "res_removeConflictingColumnsText": "Questo rimuoverà {0} colonne in conflitto dalla visualizzazione salvata. Continuare?",
      "res_replaceYourCurrentColumnConfiguration": "Sostituisci la configurazione attuale delle colonne?",
      "res_resetColumns": "Reimposta colonne",
      "res_saveAndClose": "Salva e chiudi",
      "res_saveView": "Salva visualizzazione",
      "res_search": "Cerca",
      "res_selectAll": "Seleziona tutto",
      "res_selectAView": "Seleziona una vista",
      "res_selectFixProblemText": "Seleziona Risolvi problema per rimuovere le colonne mancanti dalla visualizzazione salvata.",
      "res_selectTheCurrentOption": "Seleziona l'opzione corrente",
      "res_send": "Inviare",
      "res_sendErrorReport": "Invia rapporto di errore",
      "res_today": "Oggi",
      "res_trace": "Traccia",
      "res_undo": "Annulla",
      "res_unknown": "sconosciuto",
      "res_url": "url",
      "res_urlAllCaps": "URL",
      "res_userAgent": "Agente utente",
      "res_viewColumnManagementPanelText": "Visualizza il pannello di gestione delle colonne a destra di questa griglia per visualizzare tutte le colonne disponibili.",
      "res_viewErrorReport": "Visualizza rapporto errori",
      "res_yes": "sì"
   },
   "ja": {
      "res_am": "午前",
      "res_anErrorHasOccurred": "エラーが発生しました",
      "res_anErrorOccurredMessageLineOne": "エラーが発生したため、リクエストを完了できません。",
      "res_anErrorOccurredMessageLineTwo": "UniFocusは、今後より良いサービスを提供できるように、トラブルシューティングチームに送信できるエラーレポートを作成しました。",
      "res_applicationId": "アプリケーション ID",
      "res_at": "で",
      "res_build": "ビルド",
      "res_cancel": "[キャンセル]",
      "res_clickToSelectOrgLayer": "クリックして Org. レイヤーを選択します",
      "res_columns": "コラム",
      "res_columnsCannotBeLoaded": "列を読み込めません",
      "res_columnsCannotBeDisplayedSingleColumnText": "グリッドには 1 列しか表示できません。これはアプリケーションの更新が原因である可能性があります。",
      "res_columnsCannotBeDisplayedMultipleColumnsText": "{0} 列はグリッドに表示できません。これはアプリケーションの更新が原因である可能性があります。",
      "res_collapseAll": "すべて折りたたむ",
      "res_continue": "続行",
      "res_correlationId": "相関 ID",
      "res_current": "現在",
      "res_databaseId": "データベース ID",
      "res_delete": "[削除]",
      "res_deleteView": "ビューを削除",
      "res_deleteViewText": "これにより、保存されたビューがデータベースから完全に削除されます。このアクションは元に戻せません。",
      "res_deselectAll": "すべて選択解除",
      "res_doNothing": "何もしない",
      "res_dontSend": "送信しないでください",
      "res_errorCode": "エラーコード",
      "res_errorMessage": "エラーメッセージ",
      "res_expandAll": "すべて展開",
      "res_help": "ヘルプ",
      "res_fixProblem": "問題を修正",
      "res_hideThisColumn": "この列を非表示",
      "res_invalidInput": "入力が無効です",
      "res_load": "読み込み",
      "res_loadASavedView": "保存したビューを読み込む",
      "res_loadSaveViews": "ビューをロード/保存",
      "res_loadSelectedOrgLayer": "選択した Org. レイヤーをロード",
      "res_method": "メソッド",
      "res_newViewName": "新しいビュー名",
      "res_next": "[次へ]",
      "res_no": "いいえ",
      "res_ok": "OK",
      "res_overwrite": "上書き",
      "res_overwriteExistingViewText": "選択した名前は既に存在します。既存のビューを上書きしますか?",
      "res_partnerCode": "パートナーコード",
      "res_pm": "午後",
      "res_previous": "前へ",
      "res_problemWithSavedView": "保存されたビューに問題があります",
      "res_problemWithSavedViewMultipleColumnsText": "\\ {0}\\ という名前の保存済みビューには、アプリケーションでは使用できない {1} 列が含まれています。これはアプリケーションの更新が原因である可能性があります。",
      "res_problemWithSavedViewSingleColumnText": "\\ {0}\\ という名前の保存済みビューには、アプリケーションで使用できない列が含まれています。これはアプリケーションの更新が原因である可能性があります。",
      "res_propertyId": "プロパティ ID",
      "res_remove": "[削除]",
      "res_removeConflictingColumnText": "これにより、保存されたビューから競合する列が削除されます。続けますか?",
      "res_removeConflictingColumnsText": "これにより、保存されたビューから {0} 個の競合する列が削除されます。続けますか?",
      "res_replaceYourCurrentColumnConfiguration": "現在の列構成を置き換えますか?",
      "res_resetColumns": "列をリセット",
      "res_saveAndClose": "保存して閉じる",
      "res_saveView": "ビューを保存",
      "res_search": "検索",
      "res_selectAll": "[すべて選択]",
      "res_selectAView": "ビューを選択する",
      "res_selectFixProblemText": "「問題を修正」を選択して、保存したビューから欠落している列を削除します。",
      "res_selectTheCurrentOption": "現在のオプションを選択する",
      "res_send": "送信",
      "res_sendErrorReport": "エラーレポートを送信",
      "res_today": "今日",
      "res_trace": "トレース",
      "res_undo": "元に戻す",
      "res_unknown": "不明",
      "res_url": "URL",
      "res_urlAllCaps": "URL",
      "res_userAgent": "ユーザーエージェント",
      "res_viewColumnManagementPanelText": "このグリッドの右側にある列管理パネルを表示すると、使用可能なすべての列が表示されます。",
      "res_viewErrorReport": "エラーレポートを表示",
      "res_yes": "はい"
   },
   "ko": {
      "res_am": "오전",
      "res_anErrorHasOccurred": "오류가 발생했습니다",
      "res_anErrorOccurredMessageLineOne": "오류가 발생하여 요청을 완료할 수 없습니다.",
      "res_anErrorOccurredMessageLineTwo": "UniFocus는 향후 더 나은 서비스를 제공할 수 있도록 문제 해결 팀에 보낼 수 있는 오류 보고서를 만들었습니다.",
      "res_applicationId": "애플리케이션 ID",
      "res_at": "에서",
      "res_build": "짓다",
      "res_cancel": "취소",
      "res_clickToSelectOrgLayer": "조직 레이어를 클릭하여 선택합니다.",
      "res_columns": "칼럼",
      "res_columnsCannotBeLoaded": "열을 로드할 수 없습니다.",
      "res_columnsCannotBeDisplayedSingleColumnText": "그리드에 1개의 열을 표시할 수 없습니다.애플리케이션 업데이트 때문일 수 있습니다.",
      "res_columnsCannotBeDisplayedMultipleColumnsText": "{0} 개의 열을 그리드에 표시할 수 없습니다.애플리케이션 업데이트 때문일 수 있습니다.",
      "res_collapseAll": "모두 축소",
      "res_continue": "계속",
      "res_correlationId": "상관관계 ID",
      "res_current": "현재",
      "res_databaseId": "데이터베이스 ID",
      "res_delete": "삭제",
      "res_deleteView": "보기 삭제",
      "res_deleteViewText": "이렇게 하면 저장된 뷰가 데이터베이스에서 영구적으로 제거됩니다.이 작업은 취소할 수 없습니다.",
      "res_deselectAll": "전체 선택 취소",
      "res_doNothing": "아무것도 하지 마세요",
      "res_dontSend": "보내지 마세요",
      "res_errorCode": "오류 코드",
      "res_errorMessage": "오류 메시지",
      "res_expandAll": "모두 확장",
      "res_help": "도움말",
      "res_fixProblem": "문제 해결",
      "res_hideThisColumn": "이 칼럼 숨기기",
      "res_invalidInput": "잘못된 입력",
      "res_load": "하중",
      "res_loadASavedView": "저장된 뷰 불러오기",
      "res_loadSaveViews": "뷰 로드/저장",
      "res_loadSelectedOrgLayer": "선택한 조직 레이어 불러오기",
      "res_method": "메서드",
      "res_newViewName": "새 뷰 이름",
      "res_next": "다음",
      "res_no": "아니요",
      "res_ok": "확인",
      "res_overwrite": "덮어쓰기",
      "res_overwriteExistingViewText": "선택한 이름이 이미 있습니다.기존 뷰를 덮어쓰시겠습니까?",
      "res_partnerCode": "파트너 코드",
      "res_pm": "오후",
      "res_previous": "이전",
      "res_problemWithSavedView": "저장된 뷰 관련 문제",
      "res_problemWithSavedViewMultipleColumnsText": "이름이\\ {0}\\ 인 저장된 뷰에는 응용 프로그램에서 사용할 수 없는 {1} 개의 열이 있습니다.이는 애플리케이션 업데이트 때문일 수 있습니다.",
      "res_problemWithSavedViewSingleColumnText": "이름이\\ {0}\\ 인 저장된 뷰에는 응용 프로그램에서 사용할 수 없는 열이 포함되어 있습니다.이는 애플리케이션 업데이트 때문일 수 있습니다.",
      "res_propertyId": "프로퍼티 ID",
      "res_remove": "제거",
      "res_removeConflictingColumnText": "이렇게 하면 저장된 보기에서 충돌하는 열이 제거됩니다.계속 하시겠습니까?",
      "res_removeConflictingColumnsText": "이렇게 하면 저장된 뷰에서 충돌하는 {0} 개의 열이 제거됩니다.계속할까요?",
      "res_replaceYourCurrentColumnConfiguration": "현재 컬럼 구성을 바꾸시겠습니까?",
      "res_resetColumns": "열 재설정",
      "res_saveAndClose": "저장 후 닫기",
      "res_saveView": "보기 저장",
      "res_search": "검색",
      "res_selectAll": "모두 선택",
      "res_selectAView": "보기 선택",
      "res_selectFixProblemText": "문제 해결을 선택하여 저장된 보기에서 누락된 열을 제거합니다.",
      "res_selectTheCurrentOption": "현재 옵션을 선택합니다.",
      "res_send": "보내기",
      "res_sendErrorReport": "오류 보고서 전송",
      "res_today": "오늘",
      "res_trace": "트레이스",
      "res_undo": "실행 취소",
      "res_unknown": "알 수 없습니다",
      "res_url": "url",
      "res_urlAllCaps": "URL",
      "res_userAgent": "유저 에이전트",
      "res_viewColumnManagementPanelText": "이 그리드의 오른쪽에 있는 열 관리 패널을 보면 사용 가능한 열을 모두 볼 수 있습니다.",
      "res_viewErrorReport": "오류 보고서 보기",
      "res_yes": "예"
   },
   "ms": {
      "res_am": "SAYA",
      "res_anErrorHasOccurred": "Kesalahan Telah Berlaku",
      "res_anErrorOccurredMessageLineOne": "Ralat berlaku dan permintaan anda tidak dapat diselesaikan.",
      "res_anErrorOccurredMessageLineTwo": "UniFocus telah membuat laporan ralat yang boleh anda hantar kepada pasukan penyelesaian masalah kami, supaya kami dapat memberikan perkhidmatan yang lebih baik pada masa akan datang.",
      "res_applicationId": "Id Permohonan",
      "res_at": "Di",
      "res_build": "Membina",
      "res_cancel": "Batalkan",
      "res_clickToSelectOrgLayer": "Klik untuk memilih org. lapisan",
      "res_columns": "Lajur",
      "res_columnsCannotBeLoaded": "Lajur tidak boleh dimuatkan",
      "res_columnsCannotBeDisplayedSingleColumnText": "1 lajur tidak tersedia untuk dipaparkan dalam grid anda. Ini mungkin disebabkan oleh kemas kini aplikasi.",
      "res_columnsCannotBeDisplayedMultipleColumnsText": "Lajur {0} tidak tersedia untuk dipaparkan dalam grid anda. Ini mungkin disebabkan oleh kemas kini aplikasi.",
      "res_collapseAll": "Runtuhkan Semua",
      "res_continue": "Teruskan",
      "res_correlationId": "ID korelasi",
      "res_current": "Semasa",
      "res_databaseId": "ID Pangkalan Data",
      "res_delete": "Padam",
      "res_deleteView": "Padam paparan",
      "res_deleteViewText": "Ini akan membuang pandangan yang disimpan secara kekal dari pangkalan data. Tindakan ini tidak boleh dibatalkan.",
      "res_deselectAll": "Nyahpilih Semua",
      "res_doNothing": "Jangan buat apa-apa",
      "res_dontSend": "Jangan hantar",
      "res_errorCode": "Kod Ralat",
      "res_errorMessage": "Mesej ralat",
      "res_expandAll": "Kembangkan Semua",
      "res_help": "Bantuan",
      "res_fixProblem": "Betulkan Masalah",
      "res_hideThisColumn": "Sembunyikan Lajur Ini",
      "res_invalidInput": "Input tidak sah",
      "res_load": "Beban",
      "res_loadASavedView": "Muatkan paparan yang disimpan",
      "res_loadSaveViews": "Muatkan/ Simpan Paparan",
      "res_loadSelectedOrgLayer": "Muatkan lapisan Org yang dipilih",
      "res_method": "Kaedah",
      "res_newViewName": "Nama paparan baru",
      "res_next": "Seterusnya",
      "res_no": "Tidak",
      "res_ok": "OK",
      "res_overwrite": "Tulis ganti",
      "res_overwriteExistingViewText": "Nama yang anda pilih sudah wujud. Adakah anda ingin menulis ganti pandangan sedia ada?",
      "res_partnerCode": "Kod Rakan Kongsi",
      "res_pm": "PETANG",
      "res_previous": "Sebelumnya",
      "res_problemWithSavedView": "Masalah dengan pandangan yang disimpan",
      "res_problemWithSavedViewMultipleColumnsText": "Paparan anda yang disimpan bernama\\ {0}\\ mengandungi {1} lajur yang tidak tersedia dalam aplikasi. Ini mungkin disebabkan oleh kemas kini aplikasi.",
      "res_problemWithSavedViewSingleColumnText": "Paparan anda yang disimpan bernama\\ {0}\\ mengandungi lajur yang tidak tersedia dalam aplikasi. Ini mungkin disebabkan oleh kemas kini aplikasi.",
      "res_propertyId": "ID Hartanah",
      "res_remove": "Keluarkan",
      "res_removeConflictingColumnText": "Ini akan membuang lajur yang bercanggah dari pandangan anda yang disimpan. Teruskan?",
      "res_removeConflictingColumnsText": "Ini akan membuang {0} lajur yang bertentangan daripada pandangan yang disimpan anda. Teruskan?",
      "res_replaceYourCurrentColumnConfiguration": "Gantikan konfigurasi lajur semasa anda?",
      "res_resetColumns": "Tetapkan semula Lajur",
      "res_saveAndClose": "Simpan dan tutup",
      "res_saveView": "Simpan paparan",
      "res_search": "Cari",
      "res_selectAll": "Pilih Semua",
      "res_selectAView": "Pilih paparan",
      "res_selectFixProblemText": "Pilih Betulkan Masalah untuk membuang lajur yang hilang dari pandangan anda yang disimpan.",
      "res_selectTheCurrentOption": "Pilih pilihan semasa",
      "res_send": "Hantar",
      "res_sendErrorReport": "Hantar Laporan Ralat",
      "res_today": "Hari ini",
      "res_trace": "Jejak",
      "res_undo": "Membatalkan",
      "res_unknown": "tidak diketahui",
      "res_url": "url",
      "res_urlAllCaps": "URL",
      "res_userAgent": "Ejen Pengguna",
      "res_viewColumnManagementPanelText": "Lihat panel pengurusan lajur di sebelah kanan grid ini untuk melihat semua lajur yang tersedia.",
      "res_viewErrorReport": "Lihat Laporan Ralat",
      "res_yes": "Ya"
   },
   "nl": {
      "res_am": "BEN",
      "res_anErrorHasOccurred": "Er is een fout opgetreden",
      "res_anErrorOccurredMessageLineOne": "Er is een fout opgetreden en uw aanvraag kan niet worden voltooid.",
      "res_anErrorOccurredMessageLineTwo": "UniFocus heeft een foutenrapport gemaakt dat u naar ons team voor probleemoplossing kunt sturen, zodat we in de toekomst betere service kunnen bieden.",
      "res_applicationId": "Applicatie-id",
      "res_at": "Bij",
      "res_build": "Bouwen",
      "res_cancel": "Annuleer",
      "res_clickToSelectOrgLayer": "Klik om een organisatielaag te selecteren",
      "res_columns": "Columns",
      "res_columnsCannotBeLoaded": "Kolommen kunnen niet worden geladen",
      "res_columnsCannotBeDisplayedSingleColumnText": "1 kolom is niet beschikbaar om in je raster te worden weergegeven. Dit kan te wijten zijn aan een update van de applicatie.",
      "res_columnsCannotBeDisplayedMultipleColumnsText": "{0} kolommen zijn niet beschikbaar om in je raster te worden weergegeven. Dit kan te wijten zijn aan een update van de applicatie.",
      "res_collapseAll": "Alles samenvouwen",
      "res_continue": "Ga verder",
      "res_correlationId": "Correlatie-ID",
      "res_current": "Actueel",
      "res_databaseId": "Database-ID",
      "res_delete": "Verwijderen",
      "res_deleteView": "Weergave verwijderen",
      "res_deleteViewText": "Hiermee wordt de opgeslagen weergave definitief uit de database verwijderd. Deze actie kan niet ongedaan worden gemaakt.",
      "res_deselectAll": "Alles deselecteren",
      "res_doNothing": "Niets doen",
      "res_dontSend": "Niet verzenden",
      "res_errorCode": "Foutcode",
      "res_errorMessage": "Foutmelding",
      "res_expandAll": "Alles uitbreiden",
      "res_help": "Hulp",
      "res_fixProblem": "Probleem oplossen",
      "res_hideThisColumn": "Deze kolom verbergen",
      "res_invalidInput": "Ongeldige invoer",
      "res_load": "Laden",
      "res_loadASavedView": "Een opgeslagen weergave laden",
      "res_loadSaveViews": "Weergaven laden/opslaan",
      "res_loadSelectedOrgLayer": "Laad de geselecteerde Org. laag",
      "res_method": "Methode",
      "res_newViewName": "Nieuwe weergavenaam",
      "res_next": "Volgende",
      "res_no": "Nee",
      "res_ok": "OKÉ",
      "res_overwrite": "Overschrijven",
      "res_overwriteExistingViewText": "De naam die je hebt geselecteerd bestaat al. Wil je de bestaande weergave overschrijven?",
      "res_partnerCode": "Code voor partners",
      "res_pm": "'S MIDDAGS",
      "res_previous": "Vorige",
      "res_problemWithSavedView": "Probleem met opgeslagen weergave",
      "res_problemWithSavedViewMultipleColumnsText": "Uw opgeslagen weergave met de naam\\ {0}\\ bevat {1} kolommen die niet beschikbaar zijn in de toepassing. Dit kan te wijten zijn aan een update van de applicatie.",
      "res_problemWithSavedViewSingleColumnText": "Uw opgeslagen weergave met de naam\\ {0}\\ bevat een kolom die niet beschikbaar is in de toepassing. Dit kan te wijten zijn aan een update van de applicatie.",
      "res_propertyId": "Eigendom-ID",
      "res_remove": "Verwijderen",
      "res_removeConflictingColumnText": "Hiermee wordt een conflicterende kolom verwijderd uit je opgeslagen weergave. Doorgaan?",
      "res_removeConflictingColumnsText": "Hiermee worden {0} conflicterende kolommen verwijderd uit je opgeslagen weergave. Doorgaan?",
      "res_replaceYourCurrentColumnConfiguration": "Je huidige kolomconfiguratie vervangen?",
      "res_resetColumns": "Kolommen opnieuw instellen",
      "res_saveAndClose": "Opslaan en sluiten",
      "res_saveView": "Bekijk opslaan",
      "res_search": "Zoek",
      "res_selectAll": "Alles selecteren",
      "res_selectAView": "Selecteer een weergave",
      "res_selectFixProblemText": "Selecteer Probleem oplossen om de ontbrekende kolommen uit de opgeslagen weergave te verwijderen.",
      "res_selectTheCurrentOption": "Selecteer de huidige optie",
      "res_send": "Verzenden",
      "res_sendErrorReport": "Foutrapport verzenden",
      "res_today": "Vandaag",
      "res_trace": "Spoor",
      "res_undo": "Ongedaan maken",
      "res_unknown": "onbekend",
      "res_url": "url",
      "res_urlAllCaps": "URL",
      "res_userAgent": "User Agent",
      "res_viewColumnManagementPanelText": "Bekijk het paneel voor kolombeheer aan de rechterkant van dit raster om alle beschikbare kolommen te bekijken.",
      "res_viewErrorReport": "Foutrapport bekijken",
      "res_yes": "Ja"
   },
   "pl": {
      "res_am": "JESTEM",
      "res_anErrorHasOccurred": "Wystąpił błąd",
      "res_anErrorOccurredMessageLineOne": "Wystąpił błąd i nie można wypełnić żądania.",
      "res_anErrorOccurredMessageLineTwo": "UniFocus stworzył raport o błędach, który możesz wysłać do naszego zespołu rozwiązywania problemów, abyśmy mogli zapewnić lepszą obsługę w przyszłości.",
      "res_applicationId": "Identyfikator aplikacji",
      "res_at": "W",
      "res_build": "Zbuduj",
      "res_cancel": "Anuluj",
      "res_clickToSelectOrgLayer": "Kliknij, aby wybrać warstwę org.",
      "res_columns": "Kolumny",
      "res_columnsCannotBeLoaded": "Nie można załadować kolumn",
      "res_columnsCannotBeDisplayedSingleColumnText": "1 kolumna nie jest dostępna do wyświetlenia w siatce. Może to być spowodowane aktualizacją aplikacji.",
      "res_columnsCannotBeDisplayedMultipleColumnsText": "{0} kolumny nie są dostępne do wyświetlania w siatce. Może to być spowodowane aktualizacją aplikacji.",
      "res_collapseAll": "Zwiń wszystko",
      "res_continue": "Kontynuować",
      "res_correlationId": "Identyfikator korelacji",
      "res_current": "Bieżący",
      "res_databaseId": "Identyfikator bazy danych",
      "res_delete": "Usuń",
      "res_deleteView": "Usuń widok",
      "res_deleteViewText": "Spowoduje to trwale usunięcie zapisanego widoku z bazy danych. Tej czynności nie można cofnąć.",
      "res_deselectAll": "Odznacz wszystko",
      "res_doNothing": "Nic nie rób",
      "res_dontSend": "Nie wysyłaj",
      "res_errorCode": "Kod błędu",
      "res_errorMessage": "Komunikat o błędzie",
      "res_expandAll": "Rozwiń wszystko",
      "res_help": "Pomocy",
      "res_fixProblem": "Napraw problem",
      "res_hideThisColumn": "Ukryj tę kolumnę",
      "res_invalidInput": "Nieprawidłowe wprowadzanie",
      "res_load": "Obciążenie",
      "res_loadASavedView": "Wczytywanie zapisanego widoku",
      "res_loadSaveViews": "Załadowanie/zapisz widoki",
      "res_loadSelectedOrgLayer": "Załaduj wybraną warstwę Org.",
      "res_method": "Metoda",
      "res_newViewName": "Nowa nazwa widoku",
      "res_next": "Kolejny",
      "res_no": "Nie",
      "res_ok": "DOBRZE",
      "res_overwrite": "Zastąp",
      "res_overwriteExistingViewText": "Wybrana nazwa już istnieje. Czy chcesz nadpisać istniejący widok?",
      "res_partnerCode": "Kod Partnera",
      "res_pm": "PO POŁUDNIU",
      "res_previous": "Poprzednie",
      "res_problemWithSavedView": "Problem z zapisanym widokiem",
      "res_problemWithSavedViewMultipleColumnsText": "Zapisany widok o nazwie\\ {0}\\ zawiera kolumny {1}, które nie są dostępne w aplikacji. Może to być spowodowane aktualizacją aplikacji.",
      "res_problemWithSavedViewSingleColumnText": "Zapisany widok o nazwie\\ {0}\\ zawiera kolumnę niedostępną w aplikacji. Może to być spowodowane aktualizacją aplikacji.",
      "res_propertyId": "Identyfikator nieruchomości",
      "res_remove": "Usuń",
      "res_removeConflictingColumnText": "Spowoduje to usunięcie sprzecznej kolumny z zapisanego widoku. Kontynuować?",
      "res_removeConflictingColumnsText": "Spowoduje to usunięcie {0} sprzecznych kolumn z zapisanego widoku. Kontynuować?",
      "res_replaceYourCurrentColumnConfiguration": "Zastąpić bieżącą konfigurację kolumny?",
      "res_resetColumns": "Zresetuj kolumny",
      "res_saveAndClose": "Zapisz i zamknij",
      "res_saveView": "Zapisz widok",
      "res_search": "Szukaj",
      "res_selectAll": "Wybierz wszystko",
      "res_selectAView": "Wybierz widok",
      "res_selectFixProblemText": "Wybierz opcję Napraw problem, aby usunąć brakujące kolumny z zapisanego widoku.",
      "res_selectTheCurrentOption": "Wybierz bieżącą opcję",
      "res_send": "Wyślij",
      "res_sendErrorReport": "Wyślij raport o błędzie",
      "res_today": "Dzisiaj",
      "res_trace": "Ślad",
      "res_undo": "Cofnij",
      "res_unknown": "nieznany",
      "res_url": "adres URL",
      "res_urlAllCaps": "URL",
      "res_userAgent": "Agent użytkownika",
      "res_viewColumnManagementPanelText": "Wyświetl panel zarządzania kolumnami po prawej stronie tej siatki, aby wyświetlić wszystkie dostępne kolumny.",
      "res_viewErrorReport": "Wyświetl raport o błędach",
      "res_yes": "tak"
   },
   "pt": {
      "res_am": "AM",
      "res_anErrorHasOccurred": "Ocorreu Um Erro",
      "res_anErrorOccurredMessageLineOne": "Ocorreu um erro e não foi possível completar o seu pedido.",
      "res_anErrorOccurredMessageLineTwo": "A UniFocus criou um relatório de erro que pode enviar para a nossa equipa de resolução de problemas, para que possamos prestar um melhor serviço no futuro.",
      "res_applicationId": "Id de Aplicação",
      "res_at": "Em",
      "res_build": "Construir",
      "res_cancel": "Cancelar",
      "res_clickToSelectOrgLayer": "Clique para selecionar uma org. camada",
      "res_columns": "Colunas",
      "res_columnsCannotBeLoaded": "Não é possível carregar as colunas",
      "res_columnsCannotBeDisplayedSingleColumnText": "1 coluna não está disponível para ser exibida na sua grelha. Isto pode dever-se a uma atualização da aplicação.",
      "res_columnsCannotBeDisplayedMultipleColumnsText": "{0} colunas não estão disponíveis para serem exibidas na sua grelha. Isto pode dever-se a uma atualização da aplicação.",
      "res_collapseAll": "Recolher tudo",
      "res_continue": "Continuar",
      "res_correlationId": "ID de correlação",
      "res_current": "Atual",
      "res_databaseId": "Identificação da base de dados",
      "res_delete": "Eliminar",
      "res_deleteView": "Excluir modo",
      "res_deleteViewText": "Esta ação irá eliminar permanentemente a vista guardada da base de dados. Esta ação não pode ser revertida.",
      "res_deselectAll": "Retirar seleção a tudo",
      "res_doNothing": "Não fazer nada",
      "res_dontSend": "Não enviar",
      "res_errorCode": "Código de Erro",
      "res_errorMessage": "Mensagem de Erro",
      "res_expandAll": "Expandir tudo",
      "res_help": "Ajuda",
      "res_fixProblem": "Resolver Problema",
      "res_hideThisColumn": "Esconder Esta Coluna",
      "res_invalidInput": "Entrada inválida",
      "res_load": "Carregar",
      "res_loadASavedView": "Carregar uma vista guardada",
      "res_loadSaveViews": "Carregar / Guardar Vistas",
      "res_loadSelectedOrgLayer": "Carregar Org. selecionada camada",
      "res_method": "Método",
      "res_newViewName": "Novo nome de vista",
      "res_next": "Próximo",
      "res_no": "Não",
      "res_ok": "OK",
      "res_overwrite": "Substituir",
      "res_overwriteExistingViewText": "O nome selecionado já existe. Deseja substituir a vista existente?",
      "res_partnerCode": "Código do Parceiro",
      "res_pm": "PM",
      "res_previous": "Anterior",
      "res_problemWithSavedView": "Problema com vista guardada",
      "res_problemWithSavedViewMultipleColumnsText": "A sua vista guardada com o nome {0} contém {1} colunas que não estão disponíveis na aplicação.  Isto pode dever-se a uma atualização da aplicação.",
      "res_problemWithSavedViewSingleColumnText": "A sua vista guardada com o nome {0} contém uma coluna que não está disponível na aplicação. Isto pode dever-se a uma atualização da aplicação.",
      "res_propertyId": "ID da propriedade",
      "res_remove": "Remover",
      "res_removeConflictingColumnText": "Esta ação irá remover uma coluna incompatível da sua vista guardada. Continuar?",
      "res_removeConflictingColumnsText": "Esta ação irá remover {0} colunas incompatíveis da sua vista guardada. Continuar?",
      "res_replaceYourCurrentColumnConfiguration": "Substituir a sua atual configuração de colunas?",
      "res_resetColumns": "Repor colunas",
      "res_saveAndClose": "Guardar e fechar",
      "res_saveView": "Salvar modo de exibição",
      "res_search": "Procurar",
      "res_selectAll": "Selecionar tudo",
      "res_selectAView": "Selecione uma vista",
      "res_selectFixProblemText": "Selecione Resolver Problema para remover as colunas em falta da sua vista guardada.",
      "res_selectTheCurrentOption": "Selecione a opção atual",
      "res_send": "Enviar",
      "res_sendErrorReport": "Enviar Relatório de Erro",
      "res_today": "Hoje",
      "res_trace": "Encontrar",
      "res_undo": "Desfazer",
      "res_unknown": "Desconhecido",
      "res_url": "url",
      "res_urlAllCaps": "URL",
      "res_userAgent": "Agente do Utilizador",
      "res_viewColumnManagementPanelText": "Verifique no painel de gestão de colunas à direita desta grelha para visualizar todas as colunas disponíveis.",
      "res_viewErrorReport": "Visualizar Relatório de Erro",
      "res_yes": "Sim"
   },
   "pt-PT": {
      "res_am": "SOU",
      "res_anErrorHasOccurred": "Ocorreu um erro",
      "res_anErrorOccurredMessageLineOne": "Ocorreu um erro e o seu pedido não pode ser concluído.",
      "res_anErrorOccurredMessageLineTwo": "A UniFocus criou um relatório de erro que pode enviar à nossa equipa de resolução de problemas, para que possamos prestar um melhor serviço no futuro.",
      "res_applicationId": "ID da aplicação",
      "res_at": "Em",
      "res_build": "Construir",
      "res_cancel": "Cancelar",
      "res_clickToSelectOrgLayer": "Clique para seleccionar uma camada de organização",
      "res_columns": "Colunas",
      "res_columnsCannotBeLoaded": "Não é possível carregar as colunas",
      "res_columnsCannotBeDisplayedSingleColumnText": "Não está disponível 1 coluna para ser apresentada na grelha. Isto pode ser devido a uma actualização da aplicação.",
      "res_columnsCannotBeDisplayedMultipleColumnsText": "{0} colunas não estão disponíveis para serem apresentadas na grelha. Isto pode ser devido a uma actualização da aplicação.",
      "res_collapseAll": "Colapsar Todos",
      "res_continue": "Continuar",
      "res_correlationId": "ID de correlação",
      "res_current": "Atual",
      "res_databaseId": "ID da base de dados",
      "res_delete": "Eliminar",
      "res_deleteView": "Eliminar vista",
      "res_deleteViewText": "Isto irá remover permanentemente a vista guardada da base de dados. Esta acção não pode ser desfeita.",
      "res_deselectAll": "Desmarcar Todos",
      "res_doNothing": "Não fazer nada",
      "res_dontSend": "Não enviar",
      "res_errorCode": "Código de erro",
      "res_errorMessage": "Mensagem de Erro",
      "res_expandAll": "Expandir tudo",
      "res_help": "Ajuda",
      "res_fixProblem": "Corrigir Problema",
      "res_hideThisColumn": "Ocultar esta coluna",
      "res_invalidInput": "Entrada inválida",
      "res_load": "Carga",
      "res_loadASavedView": "Carregar uma vista guardada",
      "res_loadSaveViews": "Carregar/Salvar Visualizações",
      "res_loadSelectedOrgLayer": "Carregar camada Org. seleccionada",
      "res_method": "Método",
      "res_newViewName": "Novo nome da vista",
      "res_next": "Seguinte",
      "res_no": "Não",
      "res_ok": "OK",
      "res_overwrite": "Substituir",
      "res_overwriteExistingViewText": "O nome que seleccionou já existe. Deseja sobrescrever a vista existente?",
      "res_partnerCode": "Código de Parceiro",
      "res_pm": "PM",
      "res_previous": "Anteriores",
      "res_problemWithSavedView": "Problema com a visualização guardada",
      "res_problemWithSavedViewMultipleColumnsText": "A vista guardada denominada\\ {0}\\ contém {1} colunas que não estão disponíveis na aplicação. Isto pode ser devido a uma actualização da aplicação.",
      "res_problemWithSavedViewSingleColumnText": "A vista guardada denominada\\ {0}\\ contém uma coluna que não está disponível na aplicação. Isto pode ser devido a uma actualização da aplicação.",
      "res_propertyId": "Identificação do Imóvel",
      "res_remove": "Remover",
      "res_removeConflictingColumnText": "Isto irá remover a coluna conflitante da vista guardada. Continuar?",
      "res_removeConflictingColumnsText": "Isto irá remover {0} colunas conflitantes da vista guardada. Continuar?",
      "res_replaceYourCurrentColumnConfiguration": "Substituir a configuração atual da coluna?",
      "res_resetColumns": "Redefinir Colunas",
      "res_saveAndClose": "Guardar e fechar",
      "res_saveView": "Salvar vista",
      "res_search": "Pesquisa",
      "res_selectAll": "Selecionar tudo",
      "res_selectAView": "Seleccione uma vista",
      "res_selectFixProblemText": "Seleccione Corrigir problema para remover as colunas ausentes da vista guardada.",
      "res_selectTheCurrentOption": "Seleccione a opção actual",
      "res_send": "Enviar",
      "res_sendErrorReport": "Enviar Relatório de Erro",
      "res_today": "Hoje",
      "res_trace": "Rastreio",
      "res_undo": "Desfazer",
      "res_unknown": "desconhecido",
      "res_url": "url",
      "res_urlAllCaps": "URL",
      "res_userAgent": "Agente de Utilizador",
      "res_viewColumnManagementPanelText": "Visualize o painel de gestão de colunas à direita desta grelha para ver todas as colunas disponíveis.",
      "res_viewErrorReport": "Ver Relatório de Erro",
      "res_yes": "Sim"
   },
   "ro": {
      "res_am": "SUNT",
      "res_anErrorHasOccurred": "A apărut o eroare",
      "res_anErrorOccurredMessageLineOne": "A apărut o eroare și solicitarea dvs. nu poate fi finalizată.",
      "res_anErrorOccurredMessageLineTwo": "UniFocus a creat un raport de eroare pe care îl puteți trimite echipei noastre de depanare, astfel încât să putem oferi servicii mai bune în viitor.",
      "res_applicationId": "ID-ul aplicației",
      "res_at": "La",
      "res_build": "Construiți",
      "res_cancel": "Anulează",
      "res_clickToSelectOrgLayer": "Faceți clic pentru a selecta un strat org.",
      "res_columns": "Coloane",
      "res_columnsCannotBeLoaded": "Coloanele nu pot fi încărcate",
      "res_columnsCannotBeDisplayedSingleColumnText": "1 coloană nu este disponibilă pentru a fi afișată în grila dvs. Acest lucru se poate datora unei actualizări a aplicației.",
      "res_columnsCannotBeDisplayedMultipleColumnsText": "Coloanele {0} nu sunt disponibile pentru a fi afișate în grila dvs. Acest lucru se poate datora unei actualizări a aplicației.",
      "res_collapseAll": "Restrângeți toate",
      "res_continue": "Continuă",
      "res_correlationId": "ID-ul corelației",
      "res_current": "Curent",
      "res_databaseId": "ID-ul bazei de date",
      "res_delete": "Șterge",
      "res_deleteView": "Ștergeți vizualizarea",
      "res_deleteViewText": "Aceasta va elimina definitiv vizualizarea salvată din baza de date. Această acțiune nu poate fi anulată.",
      "res_deselectAll": "Deselectați toate",
      "res_doNothing": "Nu face nimic",
      "res_dontSend": "Nu trimite",
      "res_errorCode": "Cod de eroare",
      "res_errorMessage": "Mesaj de eroare",
      "res_expandAll": "Extindeți toate",
      "res_help": "Ajutor",
      "res_fixProblem": "Remediați problema",
      "res_hideThisColumn": "Ascundeți această coloană",
      "res_invalidInput": "Intrare nevalidă",
      "res_load": "Încărcare",
      "res_loadASavedView": "Încărcarea unei vizualizări salvate",
      "res_loadSaveViews": "Încărcați/Salvați vizualizările",
      "res_loadSelectedOrgLayer": "Încărcați stratul Org. selectat",
      "res_method": "Metodă",
      "res_newViewName": "Nume de vizualizare nou",
      "res_next": "Urmatorul",
      "res_no": "Nu",
      "res_ok": "ACCEPTABIL",
      "res_overwrite": "Suprascrie",
      "res_overwriteExistingViewText": "Numele pe care l-ați selectat există deja. Doriți să suprascrieți vizualizarea existentă?",
      "res_partnerCode": "Codul Partenerului",
      "res_pm": "PM",
      "res_previous": "Precedent",
      "res_problemWithSavedView": "Problemă cu vizualizarea salvată",
      "res_problemWithSavedViewMultipleColumnsText": "Vizualizarea salvată numită\\ {0}\\ conține {1} coloane care nu sunt disponibile în aplicație. Acest lucru se poate datora unei actualizări a aplicației.",
      "res_problemWithSavedViewSingleColumnText": "Vizualizarea salvată numită\\ {0}\\ conține coloana care nu este disponibilă în aplicație. Acest lucru se poate datora unei actualizări a aplicației.",
      "res_propertyId": "ID-ul proprietății",
      "res_remove": "Elimină",
      "res_removeConflictingColumnText": "Aceasta va elimina coloana conflictuală din vizualizarea salvată. Continuă?",
      "res_removeConflictingColumnsText": "Aceasta va elimina {0} coloane conflictuale din vizualizarea salvată. Continuă?",
      "res_replaceYourCurrentColumnConfiguration": "Înlocuiți configurația curentă a coloanei?",
      "res_resetColumns": "Resetați coloanele",
      "res_saveAndClose": "Salvați și închideți",
      "res_saveView": "Salvați vizualizarea",
      "res_search": "Caută",
      "res_selectAll": "Selectați toate",
      "res_selectAView": "Selectați o vizualizare",
      "res_selectFixProblemText": "Selectați Remediere problemă pentru a elimina coloanele lipsă din vizualizarea salvată.",
      "res_selectTheCurrentOption": "Selectați opțiunea curentă",
      "res_send": "Trimite",
      "res_sendErrorReport": "Trimiteți raportul de eroare",
      "res_today": "Astăzi",
      "res_trace": "Traseul",
      "res_undo": "Anulează",
      "res_unknown": "necunoscut",
      "res_url": "adresa URL",
      "res_urlAllCaps": "URL",
      "res_userAgent": "Agent utilizator",
      "res_viewColumnManagementPanelText": "Vizualizați panoul de gestionare a coloanelor din dreapta acestei grile pentru a vizualiza toate coloanele disponibile.",
      "res_viewErrorReport": "Vizualizați raportul de eroare",
      "res_yes": "da"
   },
   "ru": {
      "res_am": "Я",
      "res_anErrorHasOccurred": "Произошла ошибка",
      "res_anErrorOccurredMessageLineOne": "Произошла ошибка, и ваш запрос не может быть выполнен.",
      "res_anErrorOccurredMessageLineTwo": "UniFocus создала отчет об ошибке, который вы можете отправить нашей команде по устранению неполадок, чтобы мы могли предоставлять более качественные услуги в будущем.",
      "res_applicationId": "Идентификатор приложения",
      "res_at": "В",
      "res_build": "Построить",
      "res_cancel": "Отменить",
      "res_clickToSelectOrgLayer": "Нажмите, чтобы выбрать оргслой",
      "res_columns": "Колонны",
      "res_columnsCannotBeLoaded": "Невозможно загрузить столбцы",
      "res_columnsCannotBeDisplayedSingleColumnText": "Один столбец недоступен для отображения в таблице. Это может быть связано с обновлением приложения.",
      "res_columnsCannotBeDisplayedMultipleColumnsText": "Столбцы {0} недоступны для отображения в вашей сетке. Это может быть связано с обновлением приложения.",
      "res_collapseAll": "Свернуть все",
      "res_continue": "Продолжить",
      "res_correlationId": "Идентификатор корреляции",
      "res_current": "Текущий",
      "res_databaseId": "Идентификатор базы данных",
      "res_delete": "Удалить",
      "res_deleteView": "Удалить представление",
      "res_deleteViewText": "Это навсегда удалит сохраненное представление из базы данных. Это действие нельзя отменить.",
      "res_deselectAll": "Отменить выбор всех",
      "res_doNothing": "Ничего не делай",
      "res_dontSend": "Не отправляйте",
      "res_errorCode": "Код ошибки",
      "res_errorMessage": "Сообщение об ошибке",
      "res_expandAll": "Расширить все",
      "res_help": "Помощь",
      "res_fixProblem": "Устранить проблему",
      "res_hideThisColumn": "Скрыть этот столбец",
      "res_invalidInput": "Неверный ввод",
      "res_load": "Нагрузка",
      "res_loadASavedView": "Загрузить сохраненный вид",
      "res_loadSaveViews": "Загрузить/сохранить просмотры",
      "res_loadSelectedOrgLayer": "Загрузить выбранный слой Org.",
      "res_method": "Метод",
      "res_newViewName": "Новое имя вида",
      "res_next": "Следующий",
      "res_no": "Нет",
      "res_ok": "ХОРОШО",
      "res_overwrite": "Перезаписать",
      "res_overwriteExistingViewText": "Выбранное вами имя уже существует. Хотите перезаписать существующее представление?",
      "res_partnerCode": "Код партнера",
      "res_pm": "ВЕЧЕРА",
      "res_previous": "Предыдущее",
      "res_problemWithSavedView": "Проблема с сохраненным представлением",
      "res_problemWithSavedViewMultipleColumnsText": "Сохраненное представление с именем\\ {0}\\ содержит {1} столбцы, недоступные в приложении. Это может быть связано с обновлением приложения.",
      "res_problemWithSavedViewSingleColumnText": "Сохраненное представление с именем\\ {0}\\ содержит столбец, недоступный в приложении. Это может быть связано с обновлением приложения.",
      "res_propertyId": "Идентификатор объекта",
      "res_remove": "Удалить",
      "res_removeConflictingColumnText": "Это удалит конфликтующий столбец из сохраненного представления. Продолжить?",
      "res_removeConflictingColumnsText": "Это удалит {0} конфликтующих столбцов из сохраненного представления. Продолжить?",
      "res_replaceYourCurrentColumnConfiguration": "Заменить текущую конфигурацию столбцов?",
      "res_resetColumns": "Сбросить столбцы",
      "res_saveAndClose": "Сохранить и закрыть",
      "res_saveView": "Сохранить вид",
      "res_search": "Поиск",
      "res_selectAll": "Выберите все",
      "res_selectAView": "Выберите вид",
      "res_selectFixProblemText": "Выберите «Исправить проблему», чтобы удалить недостающие столбцы из сохраненного представления.",
      "res_selectTheCurrentOption": "Выберите текущий вариант",
      "res_send": "Отправить",
      "res_sendErrorReport": "Отправить отчет об ошибке",
      "res_today": "Сегодня",
      "res_trace": "Следить",
      "res_undo": "Отменить",
      "res_unknown": "неизвестный",
      "res_url": "URL-адрес",
      "res_urlAllCaps": "URL",
      "res_userAgent": "Агент пользователя",
      "res_viewColumnManagementPanelText": "Просмотрите панель управления столбцами справа от этой таблицы, чтобы увидеть все доступные столбцы.",
      "res_viewErrorReport": "Просмотреть отчет об ошибке",
      "res_yes": "Да"
   },
   "so": {
      "res_am": "AM",
      "res_anErrorHasOccurred": "Khalad Oo Dhacay",
      "res_anErrorOccurredMessageLineOne": "Khalad ka dhacay oo codsiinkaaga la dhameystiro karin.",
      "res_anErrorOccurredMessageLineTwo": "UniFocus wuxuu abuuray war qalad ah oo aad u diri kartaan kooxdeena xaalitaanka, si aan mustaqbalka adeeg wanaagsan siinayno.",
      "res_applicationId": "Iid Codsiga",
      "res_at": "In",
      "res_build": "Dhisid",
      "res_cancel": "Baajir",
      "res_clickToSelectOrgLayer": "Riix si aad u doorto org. barka",
      "res_columns": "Kooxaha",
      "res_columnsCannotBeLoaded": "Kooxaha laga qaban karin",
      "res_columnsCannotBeDisplayedSingleColumnText": "1 saarka ma heli lahaa in loo muujiyo garoonkaaga. Tani waxa ay noqon kartaa cusboonaynta codka.",
      "res_columnsCannotBeDisplayedMultipleColumnsText": "{0} Kooxaha ma heli lahaa in la muujiyaan jiidkaaga. Tani waxa ay noqon kartaa cusboonaynta codka.",
      "res_collapseAll": "Burburin Dhammaan",
      "res_continue": "Wada",
      "res_correlationId": "ID Xiriirka",
      "res_current": "Haddaha",
      "res_databaseId": "ID Database",
      "res_delete": "Diri",
      "res_deleteView": "Diri aragti",
      "res_deleteViewText": "Tani si joogto ah ayaa aragtida la badbaaday laga saari doontaa xidhi Tallaabkan waxay dib loo sameyn karin.",
      "res_deselectAll": "Dul Doo Dhammaan",
      "res_doNothing": "Wax ka sameyn",
      "res_dontSend": "Ha dirin",
      "res_errorCode": "Koodka Khalad",
      "res_errorMessage": "Fariin Khalad",
      "res_expandAll": "Balaarin Dhammaan",
      "res_help": "Caawin",
      "res_fixProblem": "Dhibaatada Habka",
      "res_hideThisColumn": "Dhubi Qulkaan",
      "res_invalidInput": "Galka waad ah",
      "res_load": "xuska",
      "res_loadASavedView": "Qaaday aragtida la badbaaday",
      "res_loadSaveViews": "Load/Save Aragtida",
      "res_loadSelectedOrgLayer": "Load la xulay Org. saarka",
      "res_method": "Habka",
      "res_newViewName": "Magaca aragti cusub",
      "res_next": "Xiga",
      "res_no": "Maya",
      "res_ok": "WAA HAGAAG",
      "res_overwrite": "Wax ku qaaday",
      "res_overwriteExistingViewText": "Magaca aad doortay horba waxay jira. Ma doonaynaa in aad u gudbiyeen aragtida jirta?",
      "res_partnerCode": "Koodka Iskaashiga",
      "res_pm": "PM",
      "res_previous": "Hore",
      "res_problemWithSavedView": "Dhibaato ee aragtida badbaaday",
      "res_problemWithSavedViewMultipleColumnsText": "Aragtigaaga la badbaaday magacaabo\\ {0}\\ waxaa ku jira {1} kalooyinka oo aan la heli karo codsiga. Tani waxa ay noqon kartaa cusboonaynta codka.",
      "res_problemWithSavedViewSingleColumnText": "Aragtigaaga la badbaaday magacaabay\\ {0}\\ ayaa waxaa ku jira kolonka aan la heli karo codsiga. Tani waxa ay noqon kartaa cusboonaynta codka.",
      "res_propertyId": "ID Hantida",
      "res_remove": "Saari",
      "res_removeConflictingColumnText": "Tani waxay saari doontaa kolonka khilaafka aragtida badbaaday Wada?",
      "res_removeConflictingColumnsText": "Tani waxay saari doontaa {0} kalooyinka khilaafsan oo aragtida la badbaad Wada?",
      "res_replaceYourCurrentColumnConfiguration": "Bedelka sameynayaaga hadda ah?",
      "res_resetColumns": "Dib u dib u dib",
      "res_saveAndClose": "Badbaad oo xiran",
      "res_saveView": "Aragta badbaad",
      "res_search": "Raadinta",
      "res_selectAll": "Dooro Dhammaan",
      "res_selectAView": "Dooro aragti",
      "res_selectFixProblemText": "Dooro Dhibaatada Dhibaatada si aad u saaro tagumada la maqan aragtida la badbaad",
      "res_selectTheCurrentOption": "Dooro doorashada hadda",
      "res_send": "Diray",
      "res_sendErrorReport": "Diir Warbixin Khalad",
      "res_today": "Maanta",
      "res_trace": "Raad",
      "res_undo": "Co-celin",
      "res_unknown": "aan la ogaan",
      "res_url": "url",
      "res_urlAllCaps": "URL",
      "res_userAgent": "Wakaalka Isticmaale",
      "res_viewColumnManagementPanelText": "Aragta baneelka maamulka kolonka ee xaqtan si aad u aragto dhammaan sagooyinka lagu heli karo.",
      "res_viewErrorReport": "Eeg Warbixinta Khaladka",
      "res_yes": "Haa"
   },
   "sw": {
      "res_am": "NI",
      "res_anErrorHasOccurred": "Hitilafu Yametokea",
      "res_anErrorOccurredMessageLineOne": "Hitilafu lilitokea na ombi lako haliwezi kukamilika.",
      "res_anErrorOccurredMessageLineTwo": "UniFocus imeunda ripoti ya kosa unayoweza kutuma kwa timu yetu ya kutatua, ili tuweze kutoa huduma bora katika siku zijazo.",
      "res_applicationId": "ID ya Maombi",
      "res_at": "Katika",
      "res_build": "Kujenga",
      "res_cancel": "Ghairi",
      "res_clickToSelectOrgLayer": "Bonyeza kuchagua org. safu",
      "res_columns": "Nguzo",
      "res_columnsCannotBeLoaded": "Nguzo haziwezi kupakia",
      "res_columnsCannotBeDisplayedSingleColumnText": "Safu ya 1 haipatikani kuonyeshwa kwenye gridi yako. Hii inaweza kutokana na sasisho la programu.",
      "res_columnsCannotBeDisplayedMultipleColumnsText": "Nguzo za {0} hazipatikani ili kuonyeshwa kwenye gridi yako. Hii inaweza kutokana na sasisho la programu.",
      "res_collapseAll": "Kuanguka Wote",
      "res_continue": "Endelea",
      "res_correlationId": "Kitambulisho cha U",
      "res_current": "sasa",
      "res_databaseId": "Kitambulisho cha database",
      "res_delete": "Futa",
      "res_deleteView": "Futa mtazamo",
      "res_deleteViewText": "Hii itaondoa kabisa mtazamo uliohifadhiwa kutoka kwenye hifadhidata. Hatua hii haiwezi kufutwa.",
      "res_deselectAll": "Ondoa Chagua Yote",
      "res_doNothing": "Fanya chochote",
      "res_dontSend": "Usitume",
      "res_errorCode": "Nambari ya Hitilafu",
      "res_errorMessage": "Ujumbe wa kosa",
      "res_expandAll": "Panua Yote",
      "res_help": "Msaada",
      "res_fixProblem": "Kurekebisha tatizo",
      "res_hideThisColumn": "Ficha safu hii",
      "res_invalidInput": "Uingizaji mbaya",
      "res_load": "Mzigo",
      "res_loadASavedView": "Pakia mtazamo uliohifadhiwa",
      "res_loadSaveViews": "Pakia/Hifadhi Maoni",
      "res_loadSelectedOrgLayer": "Pakia Org. safu iliyochaguliwa",
      "res_method": "Njia",
      "res_newViewName": "Jina la mtazamo mpya",
      "res_next": "Ifuatayo",
      "res_no": "Hapana",
      "res_ok": "SAWA",
      "res_overwrite": "Kuandika upya",
      "res_overwriteExistingViewText": "Jina uliyochagua tayari lipo. Je! Unataka kuandika upya mtazamo uliopo?",
      "res_partnerCode": "Nambari ya Mshirika",
      "res_pm": "JIONI",
      "res_previous": "Iliyotangulia",
      "res_problemWithSavedView": "Shida na mtazamo uliohifadhi",
      "res_problemWithSavedViewMultipleColumnsText": "Mtazamo wako uliohifadhiwa jina la\\ {0}\\ una nguzo za {1} ambazo hazipatikani katika programu. Hii inaweza kutokana na sasisho la programu.",
      "res_problemWithSavedViewSingleColumnText": "Mtazamo wako uliohifadhiwa jina la\\ {0}\\ una safu ambayo haipatikani katika programu. Hii inaweza kutokana na sasisho la programu.",
      "res_propertyId": "Kitambulisho cha Mali",
      "res_remove": "Ondoa",
      "res_removeConflictingColumnText": "Hii itaondoa safu zinazopingana kutoka kwa mtazamo wako ulioko Endelea?",
      "res_removeConflictingColumnsText": "Hii itaondoa {0} safu zinazopingana kutoka kwa mtazamo wako uliohifadhiwa Endelea?",
      "res_replaceYourCurrentColumnConfiguration": "Badilisha usanidi wako wa sasa wa safu?",
      "res_resetColumns": "Weka upya Nguzo",
      "res_saveAndClose": "Hifadhi na kufunga",
      "res_saveView": "Hifadhi mtazamo",
      "res_search": "Tafuta",
      "res_selectAll": "Chagua Yote",
      "res_selectAView": "Chagua mtazamo",
      "res_selectFixProblemText": "Chagua Kurekebisha Tatizo ili kuondoa safu zilizopotea kutoka kwa mtazamo wako",
      "res_selectTheCurrentOption": "Chagua chaguo la sasa",
      "res_send": "Tuma",
      "res_sendErrorReport": "Tuma Ripoti ya Hitilafu",
      "res_today": "Leo",
      "res_trace": "Kufuatilia",
      "res_undo": "Kuondoa",
      "res_unknown": "haijulikani",
      "res_url": "url",
      "res_urlAllCaps": "KISARA",
      "res_userAgent": "Wakala wa Mtumiaji",
      "res_viewColumnManagementPanelText": "Tazama jopo la usimamizi wa safu upande wa kulia ya gridi hii ili kuona safu zote zinazopatikana.",
      "res_viewErrorReport": "Angalia Ripoti ya Hitilafu",
      "res_yes": "Ndio"
   },
   "th": {
      "res_am": "ฉัน",
      "res_anErrorHasOccurred": "เกิดข้อผิดพลาด",
      "res_anErrorOccurredMessageLineOne": "เกิดข้อผิดพลาดและคำขอของคุณไม่สามารถดำเนินการเสร็จสมบูรณ์",
      "res_anErrorOccurredMessageLineTwo": "UniFocus ได้สร้างรายงานข้อผิดพลาดที่คุณสามารถส่งไปยังทีมแก้ไขปัญหาของเราเพื่อให้เราสามารถให้บริการที่ดีขึ้นในอนาคต",
      "res_applicationId": "รหัสใบสมัคร",
      "res_at": "ที่",
      "res_build": "สร้าง",
      "res_cancel": "ยกเลิก",
      "res_clickToSelectOrgLayer": "คลิกเพื่อเลือกออร์ก. เลเยอร์",
      "res_columns": "คอลัมน์",
      "res_columnsCannotBeLoaded": "ไม่สามารถโหลดคอลัมน์ได้",
      "res_columnsCannotBeDisplayedSingleColumnText": "1 คอลัมน์ไม่สามารถแสดงในตารางของคุณได้อาจเกิดจากการอัปเดตแอปพลิเคชัน",
      "res_columnsCannotBeDisplayedMultipleColumnsText": "คอลัมน์ {0} ไม่สามารถแสดงในตารางของคุณอาจเกิดจากการอัปเดตแอปพลิเคชัน",
      "res_collapseAll": "ยุบทั้งหมด",
      "res_continue": "ดำเนินการต่อ",
      "res_correlationId": "รหัสความสัมพันธ์",
      "res_current": "ปัจจุบัน",
      "res_databaseId": "รหัสฐานข้อมูล",
      "res_delete": "ลบ",
      "res_deleteView": "ลบมุมมอง",
      "res_deleteViewText": "สิ่งนี้จะลบมุมมองที่บันทึกไว้ออกจากฐานข้อมูลอย่างถาวรการกระทำนี้ไม่สามารถยกเลิกได้",
      "res_deselectAll": "ยกเลิกการเลือกทั้งหมด",
      "res_doNothing": "ไม่ทำอะไรเลย",
      "res_dontSend": "อย่าส่ง",
      "res_errorCode": "รหัสข้อผิดพลาด",
      "res_errorMessage": "ข้อความแสดงข้อผิดพลาด",
      "res_expandAll": "ขยายทั้งหมด",
      "res_help": "ช่วยเหลือ",
      "res_fixProblem": "แก้ไขปัญหา",
      "res_hideThisColumn": "ซ่อนคอลัมน์นี้",
      "res_invalidInput": "อินพุตไม่ถูกต้อง",
      "res_load": "โหลด",
      "res_loadASavedView": "โหลดมุมมองที่บันทึกไว้",
      "res_loadSaveViews": "โหลด/บันทึกมุมมอง",
      "res_loadSelectedOrgLayer": "โหลดเลเยอร์ออร์กที่เลือก",
      "res_method": "วิธี",
      "res_newViewName": "ชื่อมุมมองใหม่",
      "res_next": "ถัดไป",
      "res_no": "ไม่",
      "res_ok": "โอเค",
      "res_overwrite": "เขียนท้าย",
      "res_overwriteExistingViewText": "ชื่อที่คุณเลือกมีอยู่แล้วคุณต้องการเขียนทับมุมมองที่มีอยู่หรือไม่?",
      "res_partnerCode": "รหัสพันธมิตร",
      "res_pm": "น.",
      "res_previous": "ก่อนหน้านี้",
      "res_problemWithSavedView": "ปัญหาเกี่ยวกับมุมมองที่บันทึกไว้",
      "res_problemWithSavedViewMultipleColumnsText": "มุมมองที่บันทึกไว้ของคุณชื่อ\\ {0}\\ ประกอบด้วย {1} คอลัมน์ ที่ไม่พร้อมใช้งานในแอปพลิเคชันอาจเกิดจากการอัปเดตแอปพลิเคชัน",
      "res_problemWithSavedViewSingleColumnText": "มุมมองที่บันทึกไว้ของคุณชื่อ\\ {0}\\ มีคอลัมน์ที่ไม่พร้อมใช้งานในแอปพลิเคชันอาจเกิดจากการอัปเดตแอปพลิเคชัน",
      "res_propertyId": "รหัสอสังหาริมทรัพย์",
      "res_remove": "ลบ",
      "res_removeConflictingColumnText": "สิ่งนี้จะลบคอลัมน์ที่ขัดแย้งกันออกจากมุมมองที่บันทึกไว้ของคุณดำเนินการต่อ?",
      "res_removeConflictingColumnsText": "วิธีนี้จะลบ {0} คอลัมน์ที่ขัดแย้งกันออกจากมุมมองที่บันทึกไว้ของคุณดำเนินการต่อ?",
      "res_replaceYourCurrentColumnConfiguration": "แทนที่การกำหนดค่าคอลัมน์ปัจจุบันของคุณ?",
      "res_resetColumns": "รีเซ็ตคอลัมน์",
      "res_saveAndClose": "บันทึกและปิด",
      "res_saveView": "บันทึกมุมมอง",
      "res_search": "ค้นหา",
      "res_selectAll": "เลือกทั้งหมด",
      "res_selectAView": "เลือกมุมมอง",
      "res_selectFixProblemText": "เลือก แก้ไขปัญหา เพื่อลบคอลัมน์ที่หายไปออกจากมุมมองที่บันทึกไว้",
      "res_selectTheCurrentOption": "เลือกตัวเลือกปัจจุบัน",
      "res_send": "ส่ง",
      "res_sendErrorReport": "ส่งรายงานข้อผิดพลาด",
      "res_today": "วันนี้",
      "res_trace": "ติดตาม",
      "res_undo": "ยกเลิก",
      "res_unknown": "ไม่รู้จัก",
      "res_url": "URL",
      "res_urlAllCaps": "URL",
      "res_userAgent": "ตัวแทนผู้ใช้",
      "res_viewColumnManagementPanelText": "ดูแผงการจัดการคอลัมน์ทางด้านขวาของตารางนี้เพื่อดูคอลัมน์ที่มีอยู่ทั้งหมด",
      "res_viewErrorReport": "ดูรายงานข้อผิดพลาด",
      "res_yes": "ใช่"
   },
   "tl": {
      "res_am": "AKO",
      "res_anErrorHasOccurred": "Isang Error Nangyari",
      "res_anErrorOccurredMessageLineOne": "Isang error ang naganap at hindi makumpleto ang iyong kahilingan.",
      "res_anErrorOccurredMessageLineTwo": "Lumikha ang UniFocus ng isang ulat ng error na maaari mong ipadala sa aming koponan sa pag-aayos, upang maaari kaming magbigay ng mas mahusay na serbisyo sa hinaharap.",
      "res_applicationId": "ID ng aplikasyon",
      "res_at": "Sa",
      "res_build": "Bumuo",
      "res_cancel": "Kanselahin",
      "res_clickToSelectOrgLayer": "Mag-click upang pumili ng isang org. layer",
      "res_columns": "Mga Haligi",
      "res_columnsCannotBeLoaded": "Hindi mai-load ang mga haligi",
      "res_columnsCannotBeDisplayedSingleColumnText": "Hindi magagamit ang 1 haligi upang maipakita sa iyong grid. Maaaring ito ay dahil sa isang pag-update ng application.",
      "res_columnsCannotBeDisplayedMultipleColumnsText": "Hindi magagamit ang {0} mga haligi upang maipakita sa iyong grid. Maaaring ito ay dahil sa isang pag-update ng application.",
      "res_collapseAll": "Bumagsak Lahat",
      "res_continue": "Magpatuloy",
      "res_correlationId": "ID ng kaugnayan",
      "res_current": "Kasalukuyang",
      "res_databaseId": "Database ID",
      "res_delete": "Tanggalin",
      "res_deleteView": "Tanggalin ang view",
      "res_deleteViewText": "Permanenteng aalisin nito ang naka-save na view mula sa database. Ang pagkilos na ito ay hindi maaaring gawin.",
      "res_deselectAll": "Tanggalin ang Lahat",
      "res_doNothing": "Huwag gumawa",
      "res_dontSend": "Huwag magpadala",
      "res_errorCode": "Code ng Error",
      "res_errorMessage": "Mensahe ng Error",
      "res_expandAll": "Palawakin ang Lahat",
      "res_help": "Tulong",
      "res_fixProblem": "Ayusin ang problema",
      "res_hideThisColumn": "Itago ang Haligi na Ito",
      "res_invalidInput": "Hindi wastong input",
      "res_load": "Pag-load",
      "res_loadASavedView": "Mag-load ng naka-save na view",
      "res_loadSaveViews": "Mag-load/I-save ng mga Pananaw",
      "res_loadSelectedOrgLayer": "I-load ang napiling Org. layer",
      "res_method": "Paraan",
      "res_newViewName": "Bagong pangalan ng view",
      "res_next": "Susunod",
      "res_no": "Hindi",
      "res_ok": "OK",
      "res_overwrite": "Magsulat ng palitan",
      "res_overwriteExistingViewText": "Ang pangalang napili mo ay umiiral na. Nais mo bang i-overwrite ang umiiral na view?",
      "res_partnerCode": "Code ng Kasosyo",
      "res_pm": "PM",
      "res_previous": "Nakaraan",
      "res_problemWithSavedView": "Problema sa nai-save na view",
      "res_problemWithSavedViewMultipleColumnsText": "Ang iyong naka-save na view na pinangalanang\\ {0}\\ ay naglalaman ng {1} mga haligi na hindi magagamit sa application. Maaaring ito ay dahil sa isang pag-update ng application.",
      "res_problemWithSavedViewSingleColumnText": "Ang iyong naka-save na view na pinangalanang\\ {0}\\ ay naglalaman ng haligi na hindi magagamit sa application. Maaaring ito ay dahil sa isang pag-update ng application.",
      "res_propertyId": "ID ng Property",
      "res_remove": "Alisin",
      "res_removeConflictingColumnText": "Aalisin nito ang magkasalungat na haligi mula sa iyong naka-save na view. Magpatuloy?",
      "res_removeConflictingColumnsText": "Aalisin nito ang {0} magkakasalungat na haligi mula sa iyong naka-save na view. Magpatuloy?",
      "res_replaceYourCurrentColumnConfiguration": "Palitan ang iyong kasalukuyang configuration ng haligi?",
      "res_resetColumns": "I-reset ang mga Haligi",
      "res_saveAndClose": "I-save at isara",
      "res_saveView": "I-save ang view",
      "res_search": "Paghahanap",
      "res_selectAll": "Piliin ang Lahat",
      "res_selectAView": "Pumili ng view",
      "res_selectFixProblemText": "Piliin ang Ayusin ang Problema upang alisin ang nawawalang haligi mula sa iyong naka-save na view.",
      "res_selectTheCurrentOption": "Piliin ang kasalukuyang pagpipilian",
      "res_send": "Ipadala",
      "res_sendErrorReport": "Magpadala ng Ulat ng Error",
      "res_today": "Ngayon",
      "res_trace": "Subaybayan",
      "res_undo": "Tanggalin",
      "res_unknown": "hindi kilala",
      "res_url": "url",
      "res_urlAllCaps": "URL",
      "res_userAgent": "Agent ng Gumagamit",
      "res_viewColumnManagementPanelText": "Tingnan ang panel ng pamamahala ng haligi sa kanan ng grid na ito upang tingnan ang lahat ng magagamit na mga haligi.",
      "res_viewErrorReport": "Tingnan ang Ulat ng Error",
      "res_yes": "Oo"
   },
   "tr": {
      "res_am": "BEN",
      "res_anErrorHasOccurred": "Bir Hata Oluştu",
      "res_anErrorOccurredMessageLineOne": "Bir hata oluştu ve isteğiniz tamamlanamadı.",
      "res_anErrorOccurredMessageLineTwo": "UniFocus, gelecekte daha iyi hizmet verebilmemiz için sorun giderme ekibimize gönderebileceğiniz bir hata raporu oluşturdu.",
      "res_applicationId": "Uygulama Kimliği",
      "res_at": "Şurada",
      "res_build": "İnşa",
      "res_cancel": "İptal",
      "res_clickToSelectOrgLayer": "Bir org. katmanı seçmek için tıklayın",
      "res_columns": "Sütunlar",
      "res_columnsCannotBeLoaded": "Sütunlar yüklenemiyor",
      "res_columnsCannotBeDisplayedSingleColumnText": "1 sütun ızgaranızda görüntülenemez. Bunun nedeni bir uygulama güncellemesi olabilir.",
      "res_columnsCannotBeDisplayedMultipleColumnsText": "{0} sütunlar ızgaranızda görüntülenemez. Bu, bir uygulama güncellemesinden kaynaklanıyor olabilir.",
      "res_collapseAll": "Tümünü Daralt",
      "res_continue": "Devamı",
      "res_correlationId": "Korelasyon Kimliği",
      "res_current": "Güncel",
      "res_databaseId": "Veritabanı Kimliği",
      "res_delete": "Sil",
      "res_deleteView": "Görünümü sil",
      "res_deleteViewText": "Bu, kaydedilen görünümü veritabanından kalıcı olarak kaldıracaktır. Bu işlem geri alınamaz.",
      "res_deselectAll": "Tümünün Seçimini Kaldır",
      "res_doNothing": "Hiçbir şey yapma",
      "res_dontSend": "Gönderme",
      "res_errorCode": "Hata Kodu",
      "res_errorMessage": "Hata Mesajı",
      "res_expandAll": "Tümünü Genişletin",
      "res_help": "Yardım",
      "res_fixProblem": "Sorunu Düzelt",
      "res_hideThisColumn": "Bu Sütunu Gizle",
      "res_invalidInput": "Geçersiz giriş",
      "res_load": "Yük",
      "res_loadASavedView": "Kaydedilmiş bir görünüm yükle",
      "res_loadSaveViews": "Görünümleri Yükle/Kaydet",
      "res_loadSelectedOrgLayer": "Seçilen Org. katmanı yükle",
      "res_method": "Yöntemi",
      "res_newViewName": "Yeni görünüm adı",
      "res_next": "Sonraki",
      "res_no": "Hayır",
      "res_ok": "TAMAM",
      "res_overwrite": "Üzerine yaz",
      "res_overwriteExistingViewText": "Seçtiğiniz isim zaten var. Mevcut görünümün üzerine yazmak ister misiniz?",
      "res_partnerCode": "İş Ortağı Kodu",
      "res_pm": "ÖĞLEDEN SONRA",
      "res_previous": "Önceki",
      "res_problemWithSavedView": "Kaydedilmiş görünümle ilgili sorun",
      "res_problemWithSavedViewMultipleColumnsText": "\\ {0}\\ adlı kaydedilmiş görünümünüz, uygulamada bulunmayan {1} sütun içerir. Bunun nedeni bir uygulama güncellemesi olabilir.",
      "res_problemWithSavedViewSingleColumnText": "\\ {0}\\ adlı kaydedilmiş görünümünüz, uygulamada bulunmayan sütun içerir. Bu, bir uygulama güncellemesinden kaynaklanıyor olabilir.",
      "res_propertyId": "Emlak Kimliği",
      "res_remove": "Kaldır",
      "res_removeConflictingColumnText": "Bu, çakışan sütunu kaydedilmiş görünümünüzden kaldıracaktır. Devamı mı?",
      "res_removeConflictingColumnsText": "Bu, kayıtlı görünümünüzden {0} çakışan sütunları kaldıracaktır. Devamı mı?",
      "res_replaceYourCurrentColumnConfiguration": "Mevcut sütun yapılandırmanızı değiştirin mi?",
      "res_resetColumns": "Sütunları Sıfırla",
      "res_saveAndClose": "Kaydet ve kapat",
      "res_saveView": "Görünümü kaydet",
      "res_search": "Arama",
      "res_selectAll": "Tümünü Seç",
      "res_selectAView": "Bir görünüm seçin",
      "res_selectFixProblemText": "Kaydedilmiş görünümünüzden eksik sütunları kaldırmak için Sorunu Düzelt'i seçin.",
      "res_selectTheCurrentOption": "Geçerli seçeneği seçin",
      "res_send": "Gönder",
      "res_sendErrorReport": "Hata Raporu Gönder",
      "res_today": "Bugün",
      "res_trace": "İzleme",
      "res_undo": "Geri al",
      "res_unknown": "bilinmeyen",
      "res_url": "URL'si",
      "res_urlAllCaps": "URL",
      "res_userAgent": "Kullanıcı Aracısı",
      "res_viewColumnManagementPanelText": "Kullanılabilir tüm sütunları görüntülemek için bu ızgaranın sağındaki sütun yönetim panelini görüntüleyin.",
      "res_viewErrorReport": "Hata Raporunu Görüntüle",
      "res_yes": "Evet"
   },
   "uk": {
      "res_am": "Я",
      "res_anErrorHasOccurred": "Сталася помилка",
      "res_anErrorOccurredMessageLineOne": "Сталася помилка, і ваш запит неможливо виконати.",
      "res_anErrorOccurredMessageLineTwo": "UniFocus створив звіт про помилки, який ви можете надіслати нашій команді з усунення несправностей, щоб ми могли надавати кращі послуги в майбутньому.",
      "res_applicationId": "Ідентифікатор програми",
      "res_at": "На",
      "res_build": "Побудувати",
      "res_cancel": "Скасувати",
      "res_clickToSelectOrgLayer": "Клацніть, щоб вибрати орган. шару",
      "res_columns": "Колони",
      "res_columnsCannotBeLoaded": "Стовпці не можуть бути завантажені",
      "res_columnsCannotBeDisplayedSingleColumnText": "1 стовпець недоступний для відображення у вашій сітці. Це може бути пов'язано з оновленням програми.",
      "res_columnsCannotBeDisplayedMultipleColumnsText": "Стовпці {0} недоступні для відображення у вашій сітці. Це може бути пов'язано з оновленням програми.",
      "res_collapseAll": "Згорнути все",
      "res_continue": "Продовжити",
      "res_correlationId": "Ідентифікатор кореляції",
      "res_current": "Струм",
      "res_databaseId": "Ідентифікатор бази",
      "res_delete": "Видалити",
      "res_deleteView": "Видалити перегляд",
      "res_deleteViewText": "Це призведе до остаточного видалення збереженого вигляду з бази даних. Цю дію неможливо скасувати.",
      "res_deselectAll": "Скасувати вибір усіх",
      "res_doNothing": "Нічого не робити",
      "res_dontSend": "Не надсилайте",
      "res_errorCode": "Код помилки",
      "res_errorMessage": "Повідомлення про помилку",
      "res_expandAll": "Розгорнути все",
      "res_help": "Допоможіть",
      "res_fixProblem": "Виправити проблему",
      "res_hideThisColumn": "Приховати цей стовпець",
      "res_invalidInput": "Некоректний вхід",
      "res_load": "Навантаження",
      "res_loadASavedView": "Завантаження збереженого вигляду",
      "res_loadSaveViews": "Завантажити/Зберегти перегляди",
      "res_loadSelectedOrgLayer": "Завантаження вибраного органного шару",
      "res_method": "Метод",
      "res_newViewName": "Нова назва перегляду",
      "res_next": "Наступний",
      "res_no": "Ні",
      "res_ok": "В ПОРЯДКУ",
      "res_overwrite": "Перезаписати",
      "res_overwriteExistingViewText": "Назва, яку ви вибрали, вже існує. Ви хочете перезаписати існуючий вигляд?",
      "res_partnerCode": "Код партнера",
      "res_pm": "ВЕЧОРА",
      "res_previous": "Попередній",
      "res_problemWithSavedView": "Проблема зі збереженим видом",
      "res_problemWithSavedViewMultipleColumnsText": "Ваш збережений вигляд з назвою\\ {0}\\ містить {1} стовпці, які недоступні в програмі. Це може бути пов'язано з оновленням програми.",
      "res_problemWithSavedViewSingleColumnText": "Ваш збережений вигляд з назвою\\ {0}\\ містить стовпець, який недоступний у програмі. Це може бути пов'язано з оновленням програми.",
      "res_propertyId": "Ідентифікатор об'єкта",
      "res_remove": "Видалити",
      "res_removeConflictingColumnText": "Це призведе до видалення конфліктуючих стовпців із збереженого вигляду. Продовжити?",
      "res_removeConflictingColumnsText": "Це призведе до видалення {0} конфліктних стовпців із збереженого вигляду. Продовжити?",
      "res_replaceYourCurrentColumnConfiguration": "Замінити поточну конфігурацію стовпців?",
      "res_resetColumns": "Скинути стовпці",
      "res_saveAndClose": "Зберегти і закрити",
      "res_saveView": "Зберегти перегляд",
      "res_search": "Пошук",
      "res_selectAll": "Вибрати все",
      "res_selectAView": "Виберіть вид",
      "res_selectFixProblemText": "Виберіть Виправити проблему, щоб видалити відсутні стовпці зі збереженого вигляду.",
      "res_selectTheCurrentOption": "Виберіть поточну опцію",
      "res_send": "Надіслати",
      "res_sendErrorReport": "Надіслати звіт про помилку",
      "res_today": "Сьогодні",
      "res_trace": "Слід",
      "res_undo": "Скасувати",
      "res_unknown": "невідомий",
      "res_url": "URL-адреса",
      "res_urlAllCaps": "URL",
      "res_userAgent": "Агент користувача",
      "res_viewColumnManagementPanelText": "Перегляньте панель керування стовпцями праворуч від цієї сітки, щоб переглянути всі доступні стовпці.",
      "res_viewErrorReport": "Переглянути звіт про помилки",
      "res_yes": "Так"
   },
   "vi": {
      "res_am": "TÔI",
      "res_anErrorHasOccurred": "Đã xảy ra lỗi",
      "res_anErrorOccurredMessageLineOne": "Đã xảy ra lỗi và yêu cầu của bạn không thể hoàn thành.",
      "res_anErrorOccurredMessageLineTwo": "UniFocus đã tạo một báo cáo lỗi mà bạn có thể gửi cho nhóm khắc phục sự cố của chúng tôi, để chúng tôi có thể cung cấp dịch vụ tốt hơn trong tương lai.",
      "res_applicationId": "Id ứng dụng",
      "res_at": "Tại",
      "res_build": "Xây dựng",
      "res_cancel": "Hủy",
      "res_clickToSelectOrgLayer": "Nhấn vào đây để chọn một lớp org.",
      "res_columns": "Cột",
      "res_columnsCannotBeLoaded": "Cột không thể được tải",
      "res_columnsCannotBeDisplayedSingleColumnText": "1 cột không có sẵn để hiển thị trong lưới của bạn. Điều này có thể là do một bản cập nhật ứng dụng.",
      "res_columnsCannotBeDisplayedMultipleColumnsText": "{0} cột không có sẵn để hiển thị trong lưới của bạn. Điều này có thể là do một bản cập nhật ứng dụng.",
      "res_collapseAll": "Thu gọn tất cả",
      "res_continue": "Tiếp tục",
      "res_correlationId": "ID tương quan",
      "res_current": "Hiện tại",
      "res_databaseId": "ID cơ sở dữ liệu",
      "res_delete": "Xóa",
      "res_deleteView": "Xóa chế độ xem",
      "res_deleteViewText": "Thao tác này sẽ xóa vĩnh viễn chế độ xem đã lưu khỏi cơ sở dữ liệu. Hành động này không thể hoàn tác.",
      "res_deselectAll": "Bỏ chọn Tất cả",
      "res_doNothing": "Không làm gì",
      "res_dontSend": "Không gửi",
      "res_errorCode": "Mã lỗi",
      "res_errorMessage": "Thông báo lỗi",
      "res_expandAll": "Mở rộng tất cả",
      "res_help": "Trợ giúp",
      "res_fixProblem": "Khắc phục sự cố",
      "res_hideThisColumn": "Ẩn cột này",
      "res_invalidInput": "Đầu vào không hợp lệ",
      "res_load": "Tải",
      "res_loadASavedView": "Tải chế độ xem đã lưu",
      "res_loadSaveViews": "Nạp/Lưu Lượt xem",
      "res_loadSelectedOrgLayer": "Tải lớp Org. đã chọn",
      "res_method": "Phương pháp",
      "res_newViewName": "Tên chế độ xem mới",
      "res_next": "Tiếp theo",
      "res_no": "Không",
      "res_ok": "ĐƯỢC",
      "res_overwrite": "Ghi đè",
      "res_overwriteExistingViewText": "Tên bạn đã chọn đã tồn tại. Bạn có muốn ghi đè lên chế độ xem hiện có không?",
      "res_partnerCode": "Mã đối tác",
      "res_pm": "PM",
      "res_previous": "Trước",
      "res_problemWithSavedView": "Vấn đề với chế độ xem đã lưu",
      "res_problemWithSavedViewMultipleColumnsText": "Chế độ xem đã lưu của bạn có tên\\ {0}\\ chứa {1} cột không có sẵn trong ứng dụng. Điều này có thể là do một bản cập nhật ứng dụng.",
      "res_problemWithSavedViewSingleColumnText": "Chế độ xem đã lưu của bạn có tên\\ {0}\\ chứa cột không có sẵn trong ứng dụng. Điều này có thể là do một bản cập nhật ứng dụng.",
      "res_propertyId": "ID tài sản",
      "res_remove": "Xóa",
      "res_removeConflictingColumnText": "Thao tác này sẽ xóa cột mâu thuẫn khỏi chế độ xem đã lưu của bạn. Tiếp tục?",
      "res_removeConflictingColumnsText": "Thao tác này sẽ xóa {0} cột xung đột khỏi chế độ xem đã lưu của bạn. Tiếp tục?",
      "res_replaceYourCurrentColumnConfiguration": "Thay thế cấu hình cột hiện tại của bạn?",
      "res_resetColumns": "Đặt lại cột",
      "res_saveAndClose": "Lưu và đóng",
      "res_saveView": "Lưu chế độ xem",
      "res_search": "Tìm kiếm",
      "res_selectAll": "Chọn tất cả",
      "res_selectAView": "Chọn chế độ xem",
      "res_selectFixProblemText": "Chọn Khắc phục sự cố để xóa các cột còn thiếu khỏi chế độ xem đã lưu của bạn.",
      "res_selectTheCurrentOption": "Chọn tùy chọn hiện tại",
      "res_send": "Gửi",
      "res_sendErrorReport": "Gửi báo cáo lỗi",
      "res_today": "Hôm nay",
      "res_trace": "Theo dõi",
      "res_undo": "Hoàn tác",
      "res_unknown": "không xác định",
      "res_url": "địa chỉ",
      "res_urlAllCaps": "URL",
      "res_userAgent": "Đại lý người dùng",
      "res_viewColumnManagementPanelText": "Xem bảng quản lý cột ở bên phải của lưới này để xem tất cả các cột có sẵn.",
      "res_viewErrorReport": "Xem báo cáo lỗi",
      "res_yes": "Vâng"
   },
   "zh": {
      "res_am": "上午",
      "res_anErrorHasOccurred": "发生了错误",
      "res_anErrorOccurredMessageLineOne": "发生了错误，您的请求无法完成。",
      "res_anErrorOccurredMessageLineTwo": "UniFocus 创建了一份错误报告，您可以将其发送给我们的故障排除团队，以便我们将来提供更好的服务。",
      "res_applicationId": "应用程序编号",
      "res_at": "在",
      "res_build": "构建",
      "res_cancel": "取消",
      "res_clickToSelectOrgLayer": "点击选择组织图层",
      "res_columns": "专栏",
      "res_columnsCannotBeLoaded": "无法加载列",
      "res_columnsCannotBeDisplayedSingleColumnText": "1 列无法显示在网格中。这可能是由于应用程序更新造成的。",
      "res_columnsCannotBeDisplayedMultipleColumnsText": "{0} 列无法显示在您的网格中。这可能是由于应用程序更新造成的。",
      "res_collapseAll": "全部折叠",
      "res_continue": "继续",
      "res_correlationId": "关联 ID",
      "res_current": "当前",
      "res_databaseId": "数据库 ID",
      "res_delete": "删除",
      "res_deleteView": "删除视图",
      "res_deleteViewText": "这将从数据库中永久删除保存的视图。此操作无法撤消。",
      "res_deselectAll": "全部取消选择",
      "res_doNothing": "什么都不做",
      "res_dontSend": "不要发送",
      "res_errorCode": "错误码",
      "res_errorMessage": "错误消息",
      "res_expandAll": "全部展开",
      "res_help": "帮帮我",
      "res_fixProblem": "修复问题",
      "res_hideThisColumn": "隐藏此专栏",
      "res_invalidInput": "输入无效",
      "res_load": "加载",
      "res_loadASavedView": "加载保存的视图",
      "res_loadSaveViews": "加载/保存视图",
      "res_loadSelectedOrgLayer": "加载选定的组织层",
      "res_method": "方法",
      "res_newViewName": "新视图名称",
      "res_next": "下一步",
      "res_no": "没有",
      "res_ok": "行",
      "res_overwrite": "覆盖",
      "res_overwriteExistingViewText": "您选择的名称已经存在。你想覆盖现有视图吗？",
      "res_partnerCode": "合作伙伴代码",
      "res_pm": "下午",
      "res_previous": "以前",
      "res_problemWithSavedView": "保存的视图出现问题",
      "res_problemWithSavedViewMultipleColumnsText": "您保存的名为\\ {0}\\ 的视图包含应用程序中不可用的 {1} 列。这可能是由于应用程序更新造成的。",
      "res_problemWithSavedViewSingleColumnText": "您保存的名为\\ {0}\\ 的视图包含应用程序中不可用的列。这可能是由于应用程序更新造成的。",
      "res_propertyId": "房产编号",
      "res_remove": "移除",
      "res_removeConflictingColumnText": "这将从您保存的视图中删除冲突列。继续？",
      "res_removeConflictingColumnsText": "这将从您保存的视图中移除 {0} 个冲突列。继续？",
      "res_replaceYourCurrentColumnConfiguration": "替换您当前的列配置？",
      "res_resetColumns": "重置列",
      "res_saveAndClose": "保存并关闭",
      "res_saveView": "保存视图",
      "res_search": "搜寻",
      "res_selectAll": "选择全部",
      "res_selectAView": "选择视图",
      "res_selectFixProblemText": "选择 “修复问题” 以从保存的视图中移除缺失的列。",
      "res_selectTheCurrentOption": "选择当前选项",
      "res_send": "发送",
      "res_sendErrorReport": "发送错误报告",
      "res_today": "今天",
      "res_trace": "追踪",
      "res_undo": "撤消",
      "res_unknown": "未知",
      "res_url": "网址",
      "res_urlAllCaps": "网址",
      "res_userAgent": "用户代理",
      "res_viewColumnManagementPanelText": "查看此网格右侧的列管理面板以查看所有可用列。",
      "res_viewErrorReport": "查看错误报告",
      "res_yes": "是的"
   }
};

export default messages;
